import {Component, OnInit, OnDestroy, HostListener, ViewChild, EventEmitter, SimpleChanges} from '@angular/core';
import {interval, Observable} from "rxjs";

import {Subscription} from "rxjs";

import {Location} from '@angular/common';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import * as Communication from '../communication/index';
import { Config } from '../../environments/environment';
import {ToolbarService} from "../shared/common/ToolbarEventService";
import {ToolbarEventPageEnum} from "../shared/common/ToolbarEvent";
import {ToolbarEvent} from "../shared/common/ToolbarEvent";
import {NavigationService} from "../shared/common/NavigationEventService";
import {NotificationService} from "../shared/common/NotificationService";
import {legacyRedirectUrl, needsLegacyApp} from "../shared/common/legacy-redirect";
import {NavigationEvent} from "../shared/common/NavigationEvent";
import {Authorization} from "../shared/authorization/authorization.component";
import {isNullOrUndefined} from "util";
import {TranslateService} from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import {DomSanitizer} from "@angular/platform-browser";
import {isEmpty} from "rxjs";
import { SignaturePad } from 'angular-signature-pad-v2';
// NOTE: Fabric.js import disabled - now using HTML signature overlays
// import * as fabric from 'fabric';
import Swal from 'sweetalert2';
import {PdfViewerControlService} from '../shared/common/PdfViewerControl.service';
import {FormElementService} from '../shared/common/FormElement.service';
import {DisclosureService, DisclosureRequirement} from '../shared/services/disclosure.service';

// Shared signing services
import { HwcryptoService, HwcryptoCertificate } from '../shared/services/hwcrypto.service';
import { MobileSigningService } from '../shared/services/mobile-signing.service';
import { SigningStatusService, SigningStatus, StatusPollResult } from '../shared/services/signing-status.service';
import { DigitalSignerModalComponent, SigningResult } from '../shared/components/digital-signer-modal/digital-signer-modal.component';
import { FillingHelperService, FillingStop, SIGNATURE_STOP_TYPES } from './filling-helper.service';


declare var $:any;
declare var hwcrypto:any;

/**
 * This class represents the lazy loaded Signing_cadesComponent.
 */
@Component({
    selector: 'sd-signing',
    templateUrl: 'signing.component.html',
    styleUrls: ['signing.component.css'],
    providers: [Communication.JobsService, Communication.DocumentsService, Communication.FieldsService, Communication.RecipientRequestService, Communication.RecipientsService, Communication.AttachmentsService, DisclosureService, FillingHelperService],
    standalone: false
})
export class SigningComponent implements OnInit, OnDestroy{

  @ViewChild('ng2PdfViewer') ng2PdfViewer: any; // ng2-pdf-viewer reference
  @ViewChild('digitalSignerModal') digitalSignerModal: any; // Shared digital signer modal

  // --- pre-signing disclosure consent gate -------------------------------------
  /** True while consent is outstanding. Fields are not fetched until it clears. */
  disclosureGateOpen: boolean = false;
  /** The requirement, text included. The same versionId is posted back on acceptance. */
  disclosure: DisclosureRequirement = null;
  disclosureModalVisible: boolean = false;
  disclosureModalOpened: boolean = false;
  disclosureLoading: boolean = false;
  disclosureSubmitting: boolean = false;
  /** Called once consent clears — this is the deferred getDocFields(). */
  private afterDisclosure: () => void = null;

  // Getter for active PDF viewer
  get pdfViewer(): any {
    return this.ng2PdfViewer;
  }

  model: {
    operator:string;
    mobile:string;
  };

  kiCitizenId:string = "";
  isSignDocumentClicked: boolean = false;
  isSignDocumentClickedMobile: boolean = false;
  showChooseCertificateText: boolean = false;
  afterPinTextEntered: boolean = false;
  signingTerminated = false;

  jobIDParameter:number;
  requestCode:string;
  signStatus:string;
  attachmentsModalVisibility:boolean=false;
  attachmentCount:number=0;
  onModalCancel:boolean=false;  //imzalama cancel tuşuna basınca aktif olcak

  theJob:Communication.Job;
  theRecipient:Communication.Recipient;
  signingReason:string="";
  signingLocation:string="";

  isMobilSignSecondPage:boolean = false; //modalda imzala düğmesine tıklandığında ikinci sayfaya geçiş
  closePage:boolean = false; //modal cancel düğmesine tıklandığında ya da en son imzalama ile ilgili bildirimler sonrası
  showPromptDialog:boolean = false; //prompt dialoğu göstermek için

  returnUrl:string;
  theDocument:Communication.Document;

  isMobilSignClicked:boolean=false;
  mobilSignModel= {};
  operators = [
    { value: 'turkcell', display: 'Turkcell' },
    { value: 'telekom', display: 'Turk Telekom' },
    { value: 'vodafone', display: 'Vodafone' }
  ];
  fingerPrint:string="";

  hwcryptoModel:any = {
    hashtype: 'SHA-256',
    backend: 'chrome',
    language: 'tr',
    filter: 'SIGN',
    certificate: ''
  };

  timerSubscription:Subscription;
  subscriptions:Subscription[] = [];
  currentToolbar:any;
  isRequestCodeUsed:boolean=false;

  signerColor = "#4A90E2";
  otherSignersColor ="#95A5A6" // Gray Blue;

  refreshCanvasSubject = new BehaviorSubject("true");
  rotationSubject = new BehaviorSubject("0");
  pdfLoading:boolean = true;
  resizeTimer:any;
  radioUpdateTimer:any;

  docFields:any = [];
  shapeId:number = 1;
  fonts = ['Arial', 'Times New Roman'];
  sizes:any = [10, 12, 14, 16, 24, 36];
  fillAlertShapes:any = [];
  previousWidth:number;

  page: number = 1;
  rotation: number = 0;
  zoom: number = 1.0;
  originalSize: boolean = true;
  showAll: boolean = true;
  pdf: any;
  ng2PdfDocument: any = null; // PDFDocumentProxy for ng2-pdf-viewer form field access
  renderText: boolean = false;

  pdfSrc: any = {
    url: '',
    httpHeaders: {
      'access_token': '1'
    }
  };
  pdfBlob: Blob | null = null;

  bioSignSelection:string = "draw";
  selectedField:any;
  @ViewChild("signaturePad", {static:false}) signaturePad: SignaturePad;
  signaturePadOptions:Object = null;
  signatureFile:any = null;
  initialsFile:any = null;
  scaledImage:any;
  uploadError:string = "";
  signatureListSelection:any;
  signType:any = []; //bio or digital
  usedSignatures:any = [];
  recipientSignatureType: string | null = null; // Stores the single signature type for the recipient ('bio', 'digital', or 'initials')
  lastShapePage:number;
  stopResizeEvent:boolean=false;
  websiteAddress:string;

  smsVerificationTimeConstant:number = 300;
  smsResendTimeConstant:number = 120;

  smsVerificationTime:number = this.smsVerificationTimeConstant;
  smsVerificationTimeText:string = "0:00";
  smsResendTime:number = this.smsResendTimeConstant;
  smsResendTimeText:string = "0:00";
  disableResendSMSButton:boolean = true;
  disableSmsVerify: boolean = false;
  smsVerificationTimerObject:any;
  smsOTPCode:string;

  stylesInput:string = "";
  stylesFonts:Array<String> = ['Cititype Michigan Sign'];
  stylesFontIndex:number = 0;

  // Signature image tracking
  recipientSignatureImage: string = ''; // Single base64 image for this recipient

  /**
   * How `recipientSignatureImage` was produced, as the value the API records.
   *
   * Stored beside the image rather than read from `bioSignSelection` when the request is built.
   * The mode is a fact about the artefact, and the selection is interface state: re-opening a
   * signed box or cancelling the modal resets it to 'draw', so a signature uploaded earlier would
   * report itself as drawn on any later request that reused it.
   */
  recipientSignatureMode: string = '';
  signatureImageObjects: Map<string, any> = new Map(); // Map<fieldId, fabricImageObject>

  BIO_SIGNATURE_CANVAS_RATIO = 3; // Width to height ratio for bio-sign canvas
  INITIALS_CANVAS_RATIO = 1.5; // Width to height ratio for initials canvas

  signaturePadCanvasHeight:number = 200;
  pdfSignatureEditor : boolean = true;

  // Signature upload constraints
  private readonly MAX_JPEG_SIZE_KB = 500;
  private readonly MAX_PNG_SIZE_KB = 1024;
  private readonly MIN_IMAGE_WIDTH = 300;
  private readonly MIN_IMAGE_HEIGHT = 200;
  private readonly SIGNATURE_CANVAS_WIDTH = 600;
  private readonly SIGNATURE_CANVAS_HEIGHT = 200;
  private readonly WHITE_PIXEL_THRESHOLD = 225;

  // Form field management with Fabric.js
  fabricCanvases: Map<number, any> = new Map(); // pageNumber -> fabric.Canvas
  formFieldValues: { [fieldId: string]: any } = {};
  currentRecipientFields: any[] = [];
  otherRecipientFields: any[] = [];
  signatureOverlays: Map<string, any> = new Map(); // fieldId -> fabric object
  fieldsByPage: Map<number, any[]> = new Map(); // pageNumber -> fields array
  fieldsLoaded: boolean = false;

  // Filling helper.
  // fillingStops is built once, after fieldsLoaded; the field set does not change during a
  // signing session. currentStopKey is component state rather than DOM state, which is exactly
  // what lets the highlight survive an overlay teardown (zoom) or arrive before one exists
  // (lazy page render).
  fillingStops: FillingStop[] = [];
  fillingStarted: boolean = false;
  private currentStopKey: string | null = null;
  /** Set while a navigation is waiting for its page's overlay to exist. Scroll and focus run only
   *  when this matches — so a zoom rebuild re-highlights without yanking the viewport. */
  private pendingStopKey: string | null = null;

  // HTML Form Field Overlays - per-page overlay containers
  htmlFormOverlays: Map<number, HTMLElement> = new Map(); // pageNumber -> overlay div

  // HTML Signature Overlays - replaces Fabric.js canvases
  htmlSignatureOverlays: Map<number, HTMLElement> = new Map(); // pageNumber -> signature container
  signatureImageElements: Map<string, HTMLImageElement> = new Map(); // fieldId -> img element




  constructor(
    private jobsApi:Communication.JobsService,
    private fieldsApi:Communication.FieldsService,
    private documentsApi:Communication.DocumentsService,
    private recipientRequestApi: Communication.RecipientRequestService,
    private activatedRoute: ActivatedRoute,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private toolbarService: ToolbarService,
    private authorization: Authorization,
    private navigationService:NavigationService,
    private notificationService: NotificationService,
    public translate: TranslateService,
    private domSanitizer: DomSanitizer,
    private recipientsApi: Communication.RecipientsService,
    private pdfViewerControl: PdfViewerControlService,
    private formElementService: FormElementService,
    // Shared signing services
    private hwcryptoService: HwcryptoService,
    private mobileSigningService: MobileSigningService,
    private signingStatusService: SigningStatusService,
    private attachmentsApi: Communication.AttachmentsService,
    private disclosureService: DisclosureService,
    public filling: FillingHelperService
  ){

    // pdfDefaultOptions.enableSignatureEditor = true;



    this.websiteAddress = Config.WEBSITE;
    this.afterLoadComplete = this.afterLoadComplete.bind(this);
  }

   afterLoadComplete(pdf: any) {
     this.pdf = pdf;
     this.pdfLoading = false;

     console.log("PDF loaded with", pdf.numPages || pdf._pdfInfo?.numPages, "pages");

     // Store PDFDocumentProxy for ng2-pdf-viewer form field access
     this.ng2PdfDocument = pdf;
     console.log("PDFDocumentProxy stored for ng2-pdf-viewer");

     // Register PDF viewer with control service for pause/resume functionality
     if (this.pdfViewer) {
       // ng2-pdf-viewer doesn't have ngOnChanges, create stub adapter
       this.pdfViewerControl.registerPdfViewer(this.pdfViewer, () => {
         // Stub function for ng2-pdf-viewer compatibility
       });
     }

     // Force a resize/redraw to fix initial sizing issues
     // This ensures the PDF viewer properly fills its container
     setTimeout(() => {
       window.dispatchEvent(new Event('resize'));
     }, 100);

     // Fields might already be loaded if getDocFields completed first
     if (this.fieldsLoaded) {
       this.initializeFormSystem();
     }
   }

   onPageRendered(event: any) {
     const pageNumber = event.pageNumber;

     // For ng2-pdf-viewer, we need to query the DOM
     const pageDiv = document.querySelector(`.page[data-page-number="${pageNumber}"]`) as HTMLElement;
     const canvas = pageDiv?.querySelector('.canvasWrapper canvas') as HTMLCanvasElement;

     console.log(`Page ${pageNumber} rendered, fieldsLoaded: ${this.fieldsLoaded}`);

     // Create HTML form field overlays for this specific page
     if (this.fieldsLoaded) {
       // Small delay to ensure DOM is updated
       setTimeout(() => {
         // Find the MAIN page canvas (not annotation widget canvases)
         const pageDiv = document.querySelector(`.page[data-page-number="${pageNumber}"]`);
         const mainCanvas = pageDiv?.querySelector('canvas[role="presentation"]') as HTMLCanvasElement;

         if (mainCanvas) {
           this.createHtmlOverlayForPage(pageNumber, mainCanvas);
           // Create HTML signature overlays for this page
           this.createSignatureOverlayForPage(pageNumber, mainCanvas);
         } else {
           console.warn(`Could not find main canvas for page ${pageNumber}`);
         }
       }, 100);
     }

     // If fields are loaded, create overlays for all fields on this page
     if (this.fieldsLoaded && this.fieldsByPage.has(pageNumber) && canvas) {
       console.log(`Page ${pageNumber} has ${this.fieldsByPage.get(pageNumber)?.length} fields`);
       // Small delay to ensure DOM is ready
       setTimeout(() => {
         // NOTE: Fabric.js disabled - now using HTML signature overlays
        // this.createOverlaysForPage(pageNumber, canvas!);
       }, 100);
     }
   }

   onTextLayerRendered(event: any) {
     // Additional event that fires when text layer is ready
     const pageNumber = event.pageNumber;
     console.log(`Text layer rendered for page ${pageNumber}`);
   }

   initializeFormSystem() {
     console.log("Initializing form system with", this.docFields.length, "fields");

     // Setup PDF form fields immediately
     this.setupPDFFormFields();

     // Build fieldsByPage mapping
     this.buildFieldsByPageMapping();

     // Try to create overlays for all pages (silent fail if page not ready)
     this.processAllPagesForOverlays();
   }

   setupPDFFormFields() {
     // Build form data for ngx-extended-pdf-viewer
     const formData: { [key: string]: any } = {};

     this.docFields.forEach((field: any) => {
       if (field.type === 'text-input' || field.type === 'checkbox' || field.type === 'radio') {
         const fieldName = field.variable || field.label || `field_${field.id}`;

         if (Number(field.recipientId) === this.theRecipient.id) {
           // Current recipient - set value
           formData[fieldName] = this.formFieldValues[field.id];
         }
         // Note: Other recipients' fields will be visually indicated with overlays
       }
     });

     // Update PDF form data (will trigger setter)
     this.pdfFormData = formData;
   }

   buildFieldsByPageMapping() {
     // Clear existing mapping
     this.fieldsByPage.clear();

     // Group fields by page number
     this.docFields.forEach((field: any) => {
       // Only include fields that need canvas overlays
       const needsOverlay =
         // Signature fields for all recipients
         (field.type === 'sign-area' || field.type === 'bio-sign' || field.type === 'initials') ||
         // Other recipients' form fields
         (Number(field.recipientId) !== this.theRecipient.id &&
          (field.type === 'text-input' || field.type === 'checkbox' || field.type === 'radio'));

       if (needsOverlay) {
         if (!this.fieldsByPage.has(field.page)) {
           this.fieldsByPage.set(field.page, []);
         }
         this.fieldsByPage.get(field.page)?.push(field);
       }
     });

     console.log("Fields by page mapping:", Array.from(this.fieldsByPage.keys()).map(page =>
       `Page ${page}: ${this.fieldsByPage.get(page)?.length} fields`));
   }

   processAllPagesForOverlays() {
     // Try to create overlays for all pages that have fields
     this.fieldsByPage.forEach((fields, pageNumber) => {
       // Find the page div first, then get the canvas within it
       const pageDiv = document.querySelector(`.page[data-page-number="${pageNumber}"]`) as HTMLElement;
       // For ng2-pdf-viewer, canvas is in .canvasWrapper
       const canvas = pageDiv?.querySelector('.canvasWrapper canvas') as HTMLCanvasElement;

       if (canvas && pageDiv) {
         console.log(`Processing overlays for already-rendered page ${pageNumber}`);
         console.log(`  Found ${fields.length} fields for this page`);
         // NOTE: Fabric.js disabled - now using HTML signature overlays
        // this.createOverlaysForPage(pageNumber, canvas);
       } else {
         console.log(`Page ${pageNumber} not rendered yet, will process when it renders`);
       }
     });
   }

  // NOTE: Fabric.js method - disabled in favor of HTML signature overlays
  // async createOverlaysForPage(pageNumber: number, pdfCanvas: HTMLCanvasElement) {
  // console.log(`Creating overlays for page ${pageNumber}`);
  //      // Get fields for this page
  // const pageFields = this.fieldsByPage.get(pageNumber);
  // if (!pageFields || pageFields.length === 0) {
  // console.log(`No fields to overlay on page ${pageNumber}`);
  // return;
  // }
  //      // If we already have a canvas, dispose and recreate it (for zoom changes)
  // if (this.fabricCanvases.has(pageNumber)) {
  // console.log(`Disposing existing canvas for page ${pageNumber} (zoom may have changed)`);
  //        // Dispose the old Fabric canvas
  // const existingCanvas = this.fabricCanvases.get(pageNumber);
  // existingCanvas.dispose();
  //        // Remove the old DOM element
  // const oldOverlayElement = document.getElementById(`signature-overlay-${pageNumber}`);
  // if (oldOverlayElement) {
  // oldOverlayElement.remove();
  // }
  //        // Clear from maps
  // this.fabricCanvases.delete(pageNumber);
  //        // Clear signature image objects for this page
  // this.docFields.forEach(field => {
  // if (field.page === pageNumber && this.signatureImageObjects.has(field.id)) {
  // this.signatureImageObjects.delete(field.id);
  // }
  // });
  //        // Fall through to recreate with new dimensions
  // }
  //      // Find the page container
  // const pageContainer = pdfCanvas.closest('.page') ||
  // pdfCanvas.closest('[data-page-number]') ||
  // pdfCanvas.parentElement;
  //   // if (!pageContainer) {
  // console.error(`Cannot find container for page ${pageNumber}`);
  // return;
  // }
  //      // Create overlay canvas
  // const overlayCanvas = document.createElement('canvas');
  // overlayCanvas.id = `signature-overlay-${pageNumber}`;
  // overlayCanvas.style.position = 'absolute';
  // overlayCanvas.style.top = '0';
  // overlayCanvas.style.left = '0';
  // overlayCanvas.style.pointerEvents = 'auto';
  // overlayCanvas.style.zIndex = '100'; // Above PDF canvas but below modals (modals are 1050)
  //      // Match PDF canvas displayed dimensions (not internal resolution)
     // Get the actual displayed size from the computed style
  // const displayWidth = pdfCanvas.offsetWidth;
  // const displayHeight = pdfCanvas.offsetHeight;
  //      // Set canvas size - let Fabric handle retina scaling
     // Don't set width/height attributes, let Fabric do it
  // overlayCanvas.style.width = displayWidth + 'px';
  // overlayCanvas.style.height = displayHeight + 'px';
  //      // Find the annotationLayer within the page container
  // const annotationLayer = pageContainer.querySelector('.annotationLayer') as HTMLElement;
  // if (!annotationLayer) {
  // console.error(`No annotationLayer found for page ${pageNumber}`);
  // return;
  // }
  //      // Append canvas to annotationLayer
  // annotationLayer.appendChild(overlayCanvas);
  //      // Initialize Fabric.js canvas
     // Let Fabric handle the sizing and retina display
  // const fabricCanvas = new fabric.Canvas(overlayCanvas, {
  // selection: false,
  // renderOnAddRemove: true,
  // preserveObjectStacking: true,
  // width: displayWidth,
  // height: displayHeight,
  // containerClass: 'fabric-overlay-container',  // Custom class for the wrapper
  // perPixelTargetFind: true,  // More precise hit detection
  // targetFindTolerance: 5  // Pixels of tolerance for object detection
  // });
  //      // Ensure the Fabric wrapper (created by Fabric.js) has proper pointer events
     // Fabric wraps our canvas in a div, so we need to check the parent after initialization
  // setTimeout(() => {
  // const wrapper = overlayCanvas.parentElement as HTMLElement;
  // if (wrapper && wrapper.className.includes('canvas-container')) {
  // wrapper.style.pointerEvents = 'auto';  // Enable events on wrapper
  // wrapper.style.position = 'absolute';
  // wrapper.style.top = '0';
  // wrapper.style.left = '0';
  // wrapper.style.zIndex = '100'; // Above PDF canvas but below modals
  // console.log(`Set pointer events on Fabric wrapper for page ${pageNumber}`);
  // }
  //        // The lower canvas should have no pointer events
  // const lowerCanvas = wrapper?.querySelector('.lower-canvas') as HTMLCanvasElement;
  // if (lowerCanvas) {
  // lowerCanvas.style.pointerEvents = 'none';
  // }
  //        // The upper canvas (interaction layer) should handle all events
  // const upperCanvas = wrapper?.querySelector('.upper-canvas') as HTMLCanvasElement;
  // if (upperCanvas) {
  // upperCanvas.style.pointerEvents = 'auto';
  // upperCanvas.style.zIndex = '101'; // Above lower canvas but below modals
  // console.log(`Set pointer events on upper canvas for page ${pageNumber}`);
  // }
  // }, 0);
  //   // this.fabricCanvases.set(pageNumber, fabricCanvas);
  //      // Add overlays for this page
  // this.addFieldOverlaysToPage(pageNumber, fabricCanvas, pdfCanvas);
  // }

  // NOTE: Fabric.js method - disabled in favor of HTML signature overlays
  // addFieldOverlaysToPage(pageNumber: number, fabricCanvas: any, pdfCanvas: HTMLCanvasElement) {
     // Get the page container to extract actual page dimensions
  // const pageContainer = pdfCanvas.closest('.page') as HTMLElement;
  //      // Extract page dimensions from the page div
  // let pageDimensions = { width: 612, height: 792 }; // defaults
  // if (pageContainer) {
       // Try to extract from style or compute from actual size
  // const styleWidth = pageContainer.style.width;
  // const styleHeight = pageContainer.style.height;
  //        // The page div has data-page-number and its dimensions in the style
       // Extract the PDF points from the page (before scaling)
       // The style uses calc() with --scale-factor, we need base dimensions
  // const pageWidthMatch = styleWidth.match(/\* ([\d.]+)px/);
  // const pageHeightMatch = styleHeight.match(/\* ([\d.]+)px/);
  //   // if (pageWidthMatch && pageHeightMatch) {
  // pageDimensions.width = parseFloat(pageWidthMatch[1]);
  // pageDimensions.height = parseFloat(pageHeightMatch[1]);
  // }
  // }
  //      // Use displayed dimensions for viewport
     // Note: fabricCanvas.width might be scaled for retina displays
  // const displayWidth = pdfCanvas.offsetWidth;
  // const displayHeight = pdfCanvas.offsetHeight;
  //      // For Fabric coordinates, we need to use the canvas's actual width/height
     // which might be different from display due to device pixel ratio
  // const fabricWidth = fabricCanvas.width || displayWidth;
  // const fabricHeight = fabricCanvas.height || displayHeight;
  //   // const viewport = {
  // width: fabricWidth,
  // height: fabricHeight,
  // scale: this.zoom || 1.0
  // };
  //   // console.log(`Adding overlays to page ${pageNumber}`);
  // console.log(`  Page dimensions (PDF points): ${pageDimensions.width}x${pageDimensions.height}`);
  // console.log(`  Display dimensions: ${displayWidth}x${displayHeight}`);
  // console.log(`  Fabric canvas dimensions: ${fabricWidth}x${fabricHeight}`);
  // console.log(`  Device pixel ratio: ${(fabricWidth / displayWidth).toFixed(2)}`);
  //      // Add signature fields (all recipients)
  // this.addSignatureFieldsToPage(pageNumber, fabricCanvas, viewport, pageDimensions);
  //      // Add disabled overlays for other recipients' form fields
  // this.addDisabledFieldOverlays(pageNumber, fabricCanvas, viewport, pageDimensions);
  //   // fabricCanvas.renderAll();
  // console.log(`Overlays added to page ${pageNumber}, canvas objects: ${fabricCanvas.getObjects().length}`);
  // }

  // NOTE: Fabric.js method - disabled in favor of HTML signature overlays
  // addSignatureFieldsToPage(pageNumber: number, fabricCanvas: any, viewport: any, pageDimensions: { width: number; height: number }) {
  // const allPageFields = this.fieldsByPage.get(pageNumber) || [];
  // const pageFields = allPageFields.filter((f: any) =>
  // f.type === 'sign-area' || f.type === 'bio-sign' || f.type === 'initials'
  // );
  //   // console.log(`Found ${pageFields.length} signature fields for page ${pageNumber}`);
  //   // pageFields.forEach((field: any) => {
  // const recipientIndex = this.theJob.recipients.findIndex((r: any) => r.id == field.recipientId);
  // const isCurrentRecipient = Number(field.recipientId) === this.theRecipient.id;
  // const color = isCurrentRecipient ? this.signerColor : this.otherSignersColor;
  //   // console.log(`Field ${field.id} (${field.type}): PDF coords x=${field.x}, y=${field.y}, w=${field.width}, h=${field.height}`);
  //        // Convert PDF coordinates to screen coordinates
       // PDF uses bottom-left origin, screen uses top-left origin
  // const screenCoords = this.pdfToScreen(field, viewport, pageDimensions);
  //   // console.log(`  -> Screen coords: x=${screenCoords.x}, y=${screenCoords.y}, w=${screenCoords.width}, h=${screenCoords.height}`);
  //        // Create colored rectangle
  // console.log(`Creating rect at: x=${screenCoords.x}, y=${screenCoords.y}, w=${screenCoords.width}, h=${screenCoords.height}`);
  // const rect = new fabric.Rect({
  // left: screenCoords.x,
  // top: screenCoords.y,
  // width: screenCoords.width,
  // height: screenCoords.height,
  // fill: this.hexToRGBA(color, '0.5'),  // More visible for testing
  // stroke: color,
  // strokeWidth: 1,  // Thicker border for visibility
  // strokeDashArray: isCurrentRecipient ? [] : [5, 5],
  // selectable: false,
  // evented: isCurrentRecipient,
  // opacity: 1,  // Full opacity for testing
  // hoverCursor: isCurrentRecipient ? 'pointer' : 'not-allowed'
  // });
  //        // Create label (recipient name at bottom)
  // const labelText = this.getFieldLabel(field);
  // const fontSize = Math.max(9, 10 * viewport.scale);
  // const text = new fabric.Text(labelText, {
  // left: screenCoords.x + screenCoords.width / 2,
  // top: screenCoords.y + screenCoords.height - (fontSize * 0.6),
  // fontSize: fontSize,
  // fontFamily: 'Arial',
  // fill: '#666',
  // originX: 'center',
  // originY: 'bottom',
  // selectable: false,
  // evented: false
  // });
  //        // Create group
  // const group = new fabric.Group([rect, text], {
  // selectable: false,
  // evented: true,  // Always allow events
  // hoverCursor: isCurrentRecipient ? 'pointer' : 'not-allowed',
  // subTargetCheck: true  // Allow events to propagate to sub-objects
  // });
  //        // Store field data as custom properties
  // (group as any).fieldId = field.id;
  // (group as any).fieldType = field.type;
  // (group as any).recipientId = field.recipientId;
  // (group as any).field = field;
  //        // Add interactivity for current recipient
  // if (isCurrentRecipient) {
  // console.log(`Setting up click handler for field ${field.id}`);
  // group.on('mousedown', () => {
  // console.log('Signature field clicked:', field);
  // this.handleSignatureFieldClick(field);
  // });
  //   // group.on('mouseover', () => {
  // rect.set('fill', this.hexToRGBA(color, '0.3'));
  // fabricCanvas.renderAll();
  // });
  //   // group.on('mouseout', () => {
  // rect.set('fill', this.hexToRGBA(color, '0.2'));
  // fabricCanvas.renderAll();
  // });
  // }
  //   // fabricCanvas.add(group);
  // this.signatureOverlays.set(field.id, group);
  // console.log(`Added group to canvas, total objects: ${fabricCanvas.getObjects().length}`);
  //        // If field is already signed and we have the image, display it
  // if (field.value === "true" && this.recipientSignatureImage) {
  // this.displaySignatureImage(field.id, decodeURIComponent(this.recipientSignatureImage));
  // }
  // });
  // }

  // NOTE: Fabric.js method - disabled in favor of HTML signature overlays
  // addDisabledFieldOverlays(pageNumber: number, fabricCanvas: any, viewport: any, pageDimensions: { width: number; height: number }) {
     // Add semi-transparent overlays for other recipients' form fields
  // const allPageFields = this.fieldsByPage.get(pageNumber) || [];
  // const otherFields = allPageFields.filter((f: any) =>
  // Number(f.recipientId) !== this.theRecipient.id &&
  // (f.type === 'text-input' || f.type === 'checkbox' || f.type === 'radio')
  // );
  //   // otherFields.forEach((field: any) => {
  // const color = this.otherSignersColor;
  //        // Convert PDF coordinates to screen coordinates
  // const screenCoords = this.pdfToScreen(field, viewport, pageDimensions);
  //        // Create semi-transparent overlay
  // const overlay = new fabric.Rect({
  // left: screenCoords.x,
  // top: screenCoords.y,
  // width: screenCoords.width,
  // height: screenCoords.height,
  // fill: this.hexToRGBA(color, '0.05'),
  // stroke: color,
  // strokeWidth: 1,
  // strokeDashArray: [3, 3],
  // selectable: false,
  // evented: false,
  // opacity: 0.5
  // });
  //   // fabricCanvas.add(overlay);
  // });
  // }

   getFieldLabel(field: any): string {
     // For signature fields, show recipient name instead of static labels
     if (field.type === 'sign-area' || field.type === 'bio-sign' || field.type === 'initials') {
       const recipient = this.theJob.recipients.find((r: any) => r.id == field.recipientId);
       return recipient ? recipient.name : '';
     }

     return field.label || '';
   }

   /**
    * Extract PDF page dimensions from DOM element's style attribute
    * Example style: "width: round(var(--scale-factor) * 612px, 1px);"
    *
    * This method reads the ACTUAL page dimensions from the PDF viewer's page div,
    * which supports any PDF page size (US Letter, A4, Legal, custom, etc.)
    */
   private extractPageDimensions(pageWrapper: Element): { width: number; height: number } {
     const style = pageWrapper.getAttribute('style') || '';

     // Extract width and height from style string
     // Handle multiple CSS formats from PDF.js:
     // - Old: width: round(var(--scale-factor) * 297.6378px)
     // - New: width: round(down, var(--scale-factor) * 297.6378px, var(--scale-round-x, 1px))
     // Pattern: var(--scale-factor) * <number>px after width:/height:
     const widthMatch = style.match(/width:[^;]*var\(--scale-factor\)\s*\*\s*(\d+(?:\.\d+)?)px/);
     const heightMatch = style.match(/height:[^;]*var\(--scale-factor\)\s*\*\s*(\d+(?:\.\d+)?)px/);

     if (widthMatch && heightMatch) {
       const width = parseFloat(widthMatch[1]);
       const height = parseFloat(heightMatch[1]);
       console.log(`📐 Page dimensions: ${width}x${height} points`);
       return { width, height };
     }

     // Fallback to US Letter if extraction fails
     console.warn('⚠️ Could not extract page dimensions from style, using US Letter default');
     console.warn('   Style:', style);
     return { width: 612, height: 792 };
   }

   /**
    * Convert PDF coordinates to screen coordinates
    * PDF coordinates: origin at bottom-left, values in PDF points
    * Screen coordinates: origin at top-left, values in pixels
    */
   pdfToScreen(field: any, viewport: any, pageDimensions: { width: number; height: number }): any {
     const canvasWidth = viewport.width;
     const canvasHeight = viewport.height;

     // Parse field coordinates as numbers (API may return strings)
     const fieldX = Number(field.x);
     const fieldY = Number(field.y);
     const fieldWidth = Number(field.width);
     const fieldHeight = Number(field.height);

     // Match form-designer's pdfRectToScreen exactly:
     // 1. Convert top-left corner of rectangle (in PDF coords: x, y+height)
     const topLeftPdfY = fieldY + fieldHeight;
     const proportionalX = fieldX / pageDimensions.width;
     const proportionalY = topLeftPdfY / pageDimensions.height;

     // 2. Convert from PDF (bottom-left origin) to screen (top-left origin)
     const screenX = proportionalX * canvasWidth;
     const screenY = (1 - proportionalY) * canvasHeight;

     // 3. Scale width and height using single scale factor
     const scale = canvasWidth / pageDimensions.width;
     const screenWidth = fieldWidth * scale;
     const screenHeight = fieldHeight * scale;

     return {
       x: Math.round(screenX),
       y: Math.round(screenY),
       width: Math.round(screenWidth),
       height: Math.round(screenHeight)
     };
   }


   handleSignatureFieldClick(field: any) {
     this.selectedField = field;

     if (field.type === 'sign-area') {
       // Digital signature - show alert via NotificationService
       this.notificationService.showDigitalSignatureRequired((isConfirmed: boolean) => {

       });

     } else if (field.type === 'bio-sign' || field.type === 'initials') {
       // Biometric signature or initials

       if (field.value === "true") {
         // Field already signed - show modal to update signature
         this.bioSignSelection = 'draw';
         this.pdfViewerControl.pausePdfViewer();
         $("#bioSignModal").modal('show');
         // Modal event listener will handle initialization
       } else if (this.recipientSignatureImage) {
         // Recipient has already signed another field - apply same signature
         this.applyExistingSignatureToField(field);
       } else {
         // First time signing - show modal
         this.bioSignSelection = 'draw';
         this.pdfViewerControl.pausePdfViewer();
         $("#bioSignModal").modal('show');
         // Modal event listener will handle initialization
       }
     }
   }


  onError($event:any){
    //console.error($event)
    //this.notificationService.documentNotFound();
  }


   ngOnInit(){
      console.log("isAuthenticated "+  this.authorization.isInitializedAfterLogin());

      // Setup Bootstrap modal event listener for SignaturePad initialization
      $('#bioSignModal').on('shown.bs.modal', () => {
        this.onBioSignModalShown();
      });

      // Resume PDF viewer when bioSign modal is closed
      $('#bioSignModal').on('hidden.bs.modal', () => {
        this.pdfViewerControl.resumePdfViewer();
      });

      this.subscriptions.push(this.navigationService.eventOccured$.subscribe(
      (event:NavigationEvent) => this.onNavigationEvent(event)
      ));

     this.subscriptions.push(this.toolbarService.eventOccured$.subscribe(
       (event: ToolbarEvent) => this.onToolbarEvent(event) //get the page info
     ));

    this.subscriptions.push(this.activatedRoute.params.subscribe(
      (param) => {
        this.requestCode = param['code'];
        console.log("sign - requestCode: "+ this.requestCode);

        if(param['code'] == null){
          //TODO:ERROR
          this.notificationService.showAccessDenied();
          return;
        }

        this.onPageResize("");
        this.GetTheJobWithRequestCode();
        this.RoutingBack();

    })
    );

    this.InitMobilFormData();
    this.updateStylesCanvas();
  }

  private onToolbarEvent(event: ToolbarEvent)
  {
    this.isRequestCodeUsed = false;
    this.currentToolbar = event;

    if(this.currentToolbar.recipientState == 'SIGNED' || this.currentToolbar.recipientState == 'DECLINED'){
      this.isRequestCodeUsed = true;
    }
  }

  isMobile(){
    return /Android|webOS|iPad|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && screen.width <= 500
  }

  initSignaturePad(width?:number, height?:number){
    this.signaturePadOptions = {
      'minWidth': 1,
      'maxWidth': 5,
      'canvasWidth': width,
      'canvasHeight': height,
      'penColor': 'rgb(0,0,139)'
    };
  }

  onBioSignModalShown(): void {
    // Modal is fully rendered, SignaturePad is ready
    try {
      this.setSignaturePadCanvas();

      // Load existing signature if available
      if (this.recipientSignatureImage && this.signaturePad) {
        const decodedImage = decodeURIComponent(this.recipientSignatureImage);
        console.log('Loading existing signature into pad');
        this.signaturePad.clear();
        this.signaturePad.fromDataURL(decodedImage);
      }
    } catch (error) {
      console.error('Error in onBioSignModalShown:', error);
    }
  }

  setSignaturePadCanvas(){
    // Check if signaturePad is initialized
    if(!this.signaturePadOptions){
      let canvasHeight:number;
      let canvasWidth:number;
      let windowWidth = this.isMobile() ? window.screen.width : window.innerWidth;

      if(this.selectedField != null){
        if(this.selectedField.type == "bio-sign"){
          canvasHeight = this.signaturePadCanvasHeight;
          canvasWidth = canvasHeight * this.BIO_SIGNATURE_CANVAS_RATIO;
        } else if(this.selectedField.type == "initials"){
          canvasHeight = this.signaturePadCanvasHeight;
          canvasWidth = canvasHeight * this.INITIALS_CANVAS_RATIO;
        }

        // Only set dimensions if we calculated them
        if (canvasWidth && canvasHeight) {

          try {
            this.initSignaturePad(canvasWidth, canvasHeight);
          } catch (error) {
            console.warn('SignaturePad not ready yet, skipping canvas resize');
            // Don't throw the error, just log it
          }
        }
      }
    }
  }

  // @HostListener('window:resize', ['$event'])
  onPageResize($event:any) {

    if(this.stopResizeEvent) {
      return;
    }

    this.stopResizeEvent = true;

    let self = this;
    let previousZoom:number = this.zoom;
    let currentZoom:number = this.zoom;

    clearTimeout(this.resizeTimer);

    this.resizeTimer = setTimeout(function() {
      let width:number = $event != "" ? $event.target.innerWidth : $(window).width();


      if(self.pdfLoading){
        console.log("---> PDF or SHAPE(s) LOADING <---");

        let timer:any = interval(500).subscribe(x => {

          if(!self.pdfLoading && self.previousWidth === undefined && currentZoom == 1){
            self.previousWidth = width;

            if (timer != null)
              timer.unsubscribe();

          } else if (!self.pdfLoading && self.previousWidth != width) {
            console.log("Run resize AFTER......");
            self.doResize(previousZoom, currentZoom, width);

            if (timer != null)
              timer.unsubscribe();
          }
        });

      } else{
        console.log("Run resize DIRECT...");
        self.doResize(previousZoom, currentZoom, width);
      }

    }, 500);

  }

  doResize(previousZoom:number, currentZoom:number, width:number){
    this.previousWidth = width;

    if(previousZoom == currentZoom) {
      if (this.docFields.length > 0) {
        this.pdfLoading = true;
        this.refreshCanvasSubject.next("true");
        // Reset pdfLoading after canvas refresh completes
        setTimeout(() => {
          this.pdfLoading = false;
        }, 100);
      }
    }
    else {
      this.zoom = currentZoom;
    }
  }

  private checkApiVersionInteroperability(job: Communication.Job): boolean {
    // An in-progress job sent under an older API version is signed on the legacy app.
    // Completed and rejected ones are only read, which this app can do.
    if (!needsLegacyApp(job)) {
      return true;
    }

    const legacyUrl = legacyRedirectUrl();
    if (!legacyUrl) {
      console.log(`Job API version ${job.apiVersion} is older than ${Config.API_VERSION} and no legacy app is configured`);
      this.notificationService.apiVersionIncompatible();
      return false;
    }

    console.log(`Job API version ${job.apiVersion} is older than ${Config.API_VERSION}, redirecting to ${legacyUrl}`);
    // localStorage is kept: the legacy app is on its own origin, so clearing it here would only
    // log the user out of this app.
    window.location.href = legacyUrl;
    return false;
  }

  GetTheJobWithRequestCode(){
     console.log("GetTheJobWithRequestCode()");

     this.subscriptions.push(this.recipientRequestApi.recipientRequestsCodeJobGet(this.requestCode).subscribe(
        (response:Communication.JobOfCode) => {

          this.theJob = response.job;
          this.theRecipient = response.recipient;
          this.jobIDParameter = this.theJob.id;

          // Check API version compatibility - redirect to legacy if needed
          if (!this.checkApiVersionInteroperability(this.theJob)) {
            return; // Version check will handle redirect, stop processing
          }

          this.getRecipientInitials();

          console.log("jobIDParameter:" + this.jobIDParameter);
          console.log("job status " + this.theJob.status);
          console.log("job type " + this.theJob.type);
          // console.log("document url " + this.pdfSrc.url);
          console.log("this.theJob.documents[0].id " + this.theJob.documents[0].id);
          console.log("Recipient " + response.recipient.email + "  isRegistered : " + response.recipient.isRegistered);

          /*//SET JOB USER LANGUAGE AS DEFAULT IF ENTERS WITHOUT LOGIN
          // update locale language and refresh page
          if (!this.authorization.isInitializedAfterLogin()) {
            let userLanguage = this.theJob.user.language;
            console.log("Entered without login, job userLanguage : " + userLanguage);

            let account = { language:userLanguage };
            localStorage.setItem('account', JSON.stringify(account));
            setTimeout(() => { location.reload(); }, 0);

          }else {*/

            let documentModel: Communication.Document = this.theJob.documents[0];
            let accessToken = this.authorization.getAccessToken();

            //DOWNLOAD DOCUMENT
            const loadPdf = async () => {
              let authorized = false;
              if (this.authorization.isInitializedAfterLogin()) {
                //with login
                let fileURL:string = Config.WEBSERVICEURL + '/documents/' + documentModel.id + '/download';
                authorized = await this.loadFile(fileURL, accessToken);

              } else {
                //without login
                let fileURL:string = Config.WEBSERVICEURL + '/recipient_requests/' + this.requestCode + '/download';
                authorized = await this.loadFile(fileURL, null);
              }
              return authorized;
            };

            loadPdf().then((authorized) => {

            //alert if document already rejected
            let byWhom: string = this.isRequestCodeUsed ? "you" : "others";
            if (this.theJob.status == "REJECTED")
              this.notificationService.documentAlreadyRejected(byWhom);

            let eventPageEnum: ToolbarEventPageEnum = ToolbarEventPageEnum.JOB_SIGN_REQUEST;
            if (this.theJob.type.toUpperCase() == "SELF") {
              eventPageEnum = ToolbarEventPageEnum.JOB_SELF_SIGNING;
              //$("#myModal").modal('show');
            }

            if(authorized){
              // The ToolbarEvent is dispatched FIRST, before the consent gate can
              // defer getDocFields(). The navbar's Decline button renders from this event
              // (navbar.component.html:159, bound to currentToolbar), so deferring the block
              // around it would remove Decline silently — no error, just a missing control —
              // and trap a signer who refuses to consent. The disclosure tells them to withdraw
              // by declining, so that route has to stay open the whole time the banner is up.
              let toolbarEvent = new ToolbarEvent(eventPageEnum, this.theJob.type, this.theJob.user.id, "WAITING", this.theJob.name, this.theJob.status, "", "", "");
              this.toolbarService.action(toolbarEvent);
              // Load attachment count for signing navbar badge
              this.loadRecipientAttachmentCount(toolbarEvent);

              // Only getDocFields() is deferred. The gate is that there are no field
              // overlays to click, not that a button is disabled; the server-side check on the
              // four signing methods is the real enforcement.
              this.resolveDisclosureGate(() => this.getDocFields());
            } else {
              this.toolbarService.action(new ToolbarEvent(ToolbarEventPageEnum.NONE,"",null,"","","","","",""));
            }

            }).catch((error) => {
              console.error('Error loading PDF:', error);
              this.toolbarService.action(new ToolbarEvent(ToolbarEventPageEnum.NONE,"",null,"","","","","",""));
            });

          //}

        }, //Bind to view
        err => {
          // Log errors if any
          console.log(err);
          if(err.error.code == 222){
            let _thisErr = this;
            this.notificationService.showRequestCodeAlreadyUsed(err.error.description, function (isConfirmed: boolean) {
              if (isConfirmed) {
                //_thisErr.router.navigate(['/doc', _thisErr.theJob.id]);
              }
            });
          }else{
            this.notificationService.displayError(err);
          }
        }
      ));

  }



  private async loadPdfWithAuth(url: string, accessToken: string): Promise<Blob | null> {
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'access_token': accessToken
        }
      });

      if (response.ok) {
        return await response.blob();
      } else {
        console.error('Failed to fetch PDF:', response.status, response.statusText);
        return null;
      }
    } catch (error) {
      console.error('Error fetching PDF:', error);
      return null;
    }
  }

  async loadFile(fileURL: string, accessToken?: string): Promise<boolean> {
    if (accessToken) {
      this.pdfBlob = await this.loadPdfWithAuth(fileURL, accessToken);
      if (this.pdfBlob) {
        this.pdfSrc.url = URL.createObjectURL(this.pdfBlob);
        return true;
      } else {
        this.notificationService.documentNotFound();
        return false;
      }
    } else {
      this.pdfSrc.url = fileURL;
      return true;
    }
  }


  // ------------------------------------------------------------------------------------
  // Pre-signing disclosure consent gate
  //
  // Sequencing matters here and is the whole reason this is a separate method. The caller has
  // already dispatched the ToolbarEvent that populates the navbar, so Decline is on screen
  // before this runs and stays there while the banner is up. Only `proceed` — getDocFields() —
  // is withheld. See signing.component.ts's caller at the loadPdf() callback.
  //
  // Nothing in here touches pdfToScreen, extractPageDimensions, createHtmlOverlayForPage or
  // createSignatureOverlayForPage: the gate decides WHEN fields are
  // fetched, never where they are drawn.
  // ------------------------------------------------------------------------------------

  /**
   * Ask the server whether this signing request needs consent, then either run `proceed` now or
   * raise the banner and run it after acceptance.
   *
   * Fails open on error. A disclosure lookup that breaks must not brick a signing link: the
   * server-side check on the four signing methods is the real gate, so the worst case here is a
   * signer who reaches the fields and is refused at signing time with a clear error, rather than
   * a signer who sees a blank page and cannot even decline.
   */
  private resolveDisclosureGate(proceed: () => void): void {
    this.afterDisclosure = proceed;

    if (!this.requestCode) {
      proceed();
      return;
    }

    this.subscriptions.push(this.disclosureService.getRequirement(this.requestCode).subscribe(
      (requirement) => {
        if (!requirement || !requirement.required || requirement.accepted || !requirement.versionId) {
          // Not required, or this recipient already accepted and has simply reloaded the page.
          proceed();
          return;
        }

        // The text arrives with the requirement, so there is no second fetch and no window in
        // which the rendered words and the recorded version could come from different reads.
        this.disclosure = requirement;
        this.disclosureGateOpen = true;
        this.disclosureLoading = false;
      },
      (err) => {
        console.error('Disclosure requirement could not be resolved; continuing', err);
        proceed();
      }
    ));
  }

  /** The disclosure name was clicked. Opening is recorded but never gated on. */
  openDisclosureModal(): void {
    this.disclosureModalVisible = true;
    this.disclosureModalOpened = true;
  }

  closeDisclosureModal(): void {
    this.disclosureModalVisible = false;
  }

  /**
   * Accept & Continue. Posts against the version id that was actually rendered — never
   * "whichever is latest" — then runs the one deferred call.
   */
  acceptDisclosure(): void {
    if (!this.disclosure || this.disclosureSubmitting) return;

    this.disclosureSubmitting = true;

    this.subscriptions.push(this.disclosureService.accept(this.requestCode, {
      disclosureVersionId: this.disclosure.versionId,
      modalOpened: this.disclosureModalOpened
    }).subscribe(
      () => {
        this.disclosureSubmitting = false;
        this.disclosureGateOpen = false;
        this.disclosureModalVisible = false;
        const proceed = this.afterDisclosure;
        this.afterDisclosure = null;
        if (proceed) proceed();
      },
      (err) => {
        this.disclosureSubmitting = false;
        this.notificationService.displayError(err);
      }
    ));
  }

  getDocFields(){
    this.subscriptions.push(this.fieldsApi.recipientRequestsCodeFieldsGet(this.requestCode).subscribe(
      (response) => {
        console.log("GET/docFields... " + this.docFields.length + " Şekil mevcut");
        console.log(response);

        let allFields:Array<Communication.DocumentField> = response;

        // Detect the recipient's signature type from fields
        for(let i=0; i<allFields.length; i++)
        {
          // Check if this is a signature field for the current recipient
          if(Number(allFields[i].recipientId) === Number(this.theRecipient.id) && !this.recipientSignatureType) {
            if(allFields[i].type === 'sign-area') {
              this.recipientSignatureType = 'digital';
              console.log('Detected signature type for recipient: digital');
            } else if(allFields[i].type === 'bio-sign') {
              this.recipientSignatureType = 'bio';
              console.log('Detected signature type for recipient: bio');
            } else if(allFields[i].type === 'initials') {
              this.recipientSignatureType = 'initials';
              console.log('Detected signature type for recipient: initials');
            }
          }

          if(allFields[i].type != "text-area") {
            let fields: any = {};
            fields.id = allFields[i].id;
            fields.documentId = allFields[i].documentId;
            fields.recipientId = allFields[i].recipientId;
            fields.page = allFields[i].page;
            fields.type = allFields[i].type;
            fields.width = allFields[i].width;
            fields.height = allFields[i].height;
            fields.x = allFields[i].x;
            fields.y = allFields[i].y;
            fields.label = allFields[i].label;
            fields.enabled = allFields[i].enabled;
            fields.initialValue = allFields[i].initialValue;
            fields.value = allFields[i].value;
            fields.variable = allFields[i].variable;
            fields.validation = allFields[i].validation;
            fields.orderno = allFields[i].orderno;
            fields.required = allFields[i].required;
            fields.options = allFields[i].options;

            if(!this.lastShapePage || this.lastShapePage < Number(fields.page)) {
              this.lastShapePage = Number(fields.page);
            }

            // Categorize fields by recipient and type
            if (Number(fields.recipientId) === this.theRecipient.id) {
              this.currentRecipientFields.push(fields);
              // Initialize form field values
              if (fields.type === 'text-input') {
                this.formFieldValues[fields.id] = fields.value || fields.initialValue || '';
              } else if (fields.type === 'checkbox') {
                this.formFieldValues[fields.id] = fields.value || fields.initialValue || '';
              } else if (fields.type === 'radio') {
                // Radio: Store by group (variable), check if this radio is selected
                const groupName = fields.variable || `radio-${fields.id}`;
                if (fields.value === 'true' || fields.value === true) {
                  // This radio is selected, store its field ID as the selected radio
                  this.formFieldValues[groupName] = fields.id.toString();
                }
              }
            } else {
              this.otherRecipientFields.push(fields);
            }

            this.docFields.push(fields);
          }
        }

        this.fieldsLoaded = true;
        console.log(`Fields loaded: ${this.currentRecipientFields.length} current, ${this.otherRecipientFields.length} other recipients`);

        // Traversal stops, in reading order. Derived from the stored PDF coordinates,
        // so this does not wait on any page having rendered.
        this.buildFillingStops();

        // Create HTML form field overlays for all visible pages after fields are loaded
        setTimeout(() => {
          // Find all rendered pages and create overlays
          document.querySelectorAll('.page[data-page-number]').forEach((pageDiv: Element) => {
            const pageNumber = parseInt((pageDiv as HTMLElement).getAttribute('data-page-number') || '0');
            // Get the MAIN page canvas (not annotation widget canvases)
            const canvas = pageDiv.querySelector('canvas[role="presentation"]') as HTMLCanvasElement;
            if (canvas && pageNumber > 0) {
              this.createHtmlOverlayForPage(pageNumber, canvas);
              // Create HTML signature overlays for this page
              this.createSignatureOverlayForPage(pageNumber, canvas);
            }
          });
        }, 300);

        // Load previously used signatures for this recipient (bio-sign and initials)
        if (this.recipientSignatureType && (this.recipientSignatureType === 'bio' || this.recipientSignatureType === 'initials')) {
          const signatureType = this.recipientSignatureType === 'bio' ? 'bio-sign' : 'initials';

          this.subscriptions.push(
            this.recipientRequestApi.recipientSignaturesCodeGet(this.requestCode, signatureType).subscribe(
              (signatures: string[]) => {
                this.usedSignatures = signatures;
                console.log(`Loaded ${signatures.length} previously used ${signatureType} signatures`);
              },
              (err) => {
                console.error(`Error loading used ${signatureType} signatures:`, err);
                // Don't show error to user - this is optional functionality
              }
            )
          );
        }

        // Initialize form system if PDF is already loaded
        if (this.pdf && !this.pdfLoading) {
          this.initializeFormSystem();
        }

        if (this.theJob.type.toUpperCase() == "SELF") {
          let allBioSignItems = allFields.filter((x:any) => x.type=="bio-sign");

          if(allBioSignItems.length == 0) {
            $("#myModal").modal('show');
          }
        }

      }, //Bind to view
      err => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err);
      }
    ));
  }

  public RoutingBack(){
     //Bkz http://jasonwatmore.com/post/2016/12/08/angular-2-redirect-to-previous-url-after-login-with-auth-guard
     this.returnUrl = this.route.snapshot.queryParams['url'] || '';
     //console.log("this.returnUrl "+ this.returnUrl);
  }

  /**
   * Initiate USB e-ID signing using HwcryptoService
   */
  public async openEidSign() {
    if (this.signingTerminated) {
      return;
    }

    this.isSignDocumentClicked = true;

    // Step 1: Get certificate from smart card using HwcryptoService
    this.isSignDocumentClicked = false;
    this.showChooseCertificateText = true;

    this.subscriptions.push(
      this.hwcryptoService.getCertificate().subscribe({
        next: (certificate: HwcryptoCertificate) => {
          if (this.signingTerminated) {
            console.log("Signing cancelled by user");
            this.resetUsbSigningState();
            return;
          }

          console.log("certificate received...");
          this.hwcryptoModel.certificate = certificate;
          this.showChooseCertificateText = false;
          this.isSignDocumentClicked = true;

          // Step 2: Get token hash from server
          this.getTokenHashAndSign(certificate);
        },
        error: (error: any) => {
          console.error("Certificate error:", error?.message || error);
          this.notificationService.OpenEIdSigningError(error?.message || 'Certificate selection failed');
          this.resetUsbSigningState();
        }
      })
    );
  }

  /**
   * Get token hash from server and sign it
   */
  private getTokenHashAndSign(certificate: HwcryptoCertificate): void {
    this.subscriptions.push(
      this.recipientRequestApi.recipientRequestsCodeTokenhashPut(
        this.requestCode,
        certificate.hex,
        this.signingReason,
        this.signingLocation
      ).subscribe({
        next: (response: any) => {
          console.log("token hash received...");
          const hash = response.resources?.[0]?.source || response.source;
          this.signWithHwcrypto(hash);
        },
        error: (err: any) => {
          console.error("Token hash error:", err);
          this.notificationService.displayError(err);
          this.resetUsbSigningState();
        }
      })
    );
  }

  /**
   * Convert base64 to hex (delegated to HwcryptoService)
   * @deprecated Use hwcryptoService.base64toHEX instead
   */
  base64toHEX(base64: string): string {
    return this.hwcryptoService.base64toHEX(base64);
  }

  /**
   * Sign the hash using HwcryptoService
   */
  signWithHwcrypto(hash: string): void {
    if (!this.hwcryptoModel.certificate) {
      this.notificationService.OpenEIdSigningError('No certificate selected');
      this.resetUsbSigningState();
      return;
    }

    this.subscriptions.push(
      this.hwcryptoService.sign(this.hwcryptoModel.certificate, hash).subscribe({
        next: (signature) => {
          console.log("signature received..");
          this.afterPinTextEntered = true;
          this.isSignDocumentClicked = false;

          // Step 3: Send signature to server
          this.sendSignatureToServer(signature.hex);
        },
        error: (error: any) => {
          console.error("Signing failed:", error?.message || error);
          this.notificationService.OpenEIdSigningError(error?.message || 'Signing failed');
          this.resetUsbSigningState();
        }
      })
    );
  }

  /**
   * Send the signature to the server
   */
  private sendSignatureToServer(signatureHex: string): void {
    this.subscriptions.push(
      this.recipientRequestApi.recipientRequestsCodeTokensignaturePost(
        this.requestCode,
        signatureHex
      ).subscribe({
        next: (response: any) => {
          console.log("Signing successful...");
          this.handleUsbSigningSuccess();
        },
        error: (err: any) => {
          console.error("Signature submission error:", err);
          this.notificationService.displayError(err);
          this.resetUsbSigningState();
        }
      })
    );
  }

  /**
   * Handle successful USB signing
   */
  private handleUsbSigningSuccess(): void {
    $("#myModal").modal('hide');

    // Handle navigation based on login state
    if (!this.authorization.isInitializedAfterLogin()) {
      this.notificationService.showJobSigned(this.theRecipient.isRegistered, (isConfirmed: boolean) => {
        if (isConfirmed) {
          this.router.navigate(['/doc', this.theJob.id]);
        }
      });
    } else {
      this.notificationService.jobSigned(this.theJob.name);
      this.RedirectReferredPage();
    }

    // Log toolbar event
    const eventPageEnum = this.theJob.type.toUpperCase() === "SELF"
      ? ToolbarEventPageEnum.JOB_SELF_SIGNING
      : ToolbarEventPageEnum.JOB_SIGN_REQUEST;

    if (this.theJob.type.toUpperCase() === "SELF") {
      this.notificationService.jobCompleted(this.theJob.name);
      this.toolbarService.action(new ToolbarEvent(
        eventPageEnum, this.theJob.type, this.theJob.user.id,
        "SIGNED", this.theJob.name, "COMPLETED", this.theJob.location, "", ""
      ));
    } else {
      this.toolbarService.action(new ToolbarEvent(
        eventPageEnum, this.theJob.type, this.theJob.user.id,
        "SIGNED", this.theJob.name, "", "", "", ""
      ));
    }
  }

  /**
   * Reset USB signing state
   */
  private resetUsbSigningState(): void {
    this.isSignDocumentClicked = false;
    this.afterPinTextEntered = false;
    this.showChooseCertificateText = false;
    this.hwcryptoModel.certificate = null;
  }


  public InitMobilFormData(){
    this.mobilSignModel = {
      mobile:"",
      operator:this.operators[0].value
    }
  }


  /**
   * Initiate mobile signing using MobileSigningService
   */
  public async mobileSign(formData: any): Promise<void> {
    console.log(`${formData.operator} ${formData.mobileNumber}`);
    this.isSignDocumentClickedMobile = true;

    this.subscriptions.push(
      this.mobileSigningService.initiateMobileSign({
        requestCode: this.requestCode,
        operator: formData.operator,
        mobile: formData.mobileNumber,
        reason: this.signingReason,
        location: this.signingLocation
      }).subscribe({
        next: (result) => {
          console.log("fingerPrint " + result.fingerPrint + " isExpectInitialSigning: " + result.isExpectInitialSigning);

          if (result.success && result.formattedFingerPrint) {
            this.isMobilSignSecondPage = true;
            this.isMobilSignClicked = false;
            this.fingerPrint = result.formattedFingerPrint;

            // Start polling for status using SigningStatusService
            this.startMobileSigningPolling();
          } else {
            this.notificationService.signingMobileSignNotFound();
            this.resetMobileSigningState();
          }
        },
        error: (err: any) => {
          console.error("Mobile sign error:", err);
          this.notificationService.displayError(err);
          this.resetMobileSigningState();
        }
      })
    );
  }

  /**
   * Start polling for mobile signing status using SigningStatusService
   */
  private startMobileSigningPolling(): void {
    this.subscriptions.push(
      this.signingStatusService.startPolling(this.requestCode).subscribe({
        next: (result: StatusPollResult) => {
          if (this.onModalCancel) {
            return; // Polling paused by user
          }
          this.handleMobileSigningStatus(result);
        },
        error: (err) => {
          console.error("Status polling error:", err);
          $("#myModal").modal('hide');
          this.notificationService.displayError(err);
        }
      })
    );
  }

  /**
   * Handle mobile signing status result
   */
  private handleMobileSigningStatus(result: StatusPollResult): void {
    console.log("Status:", result.status);

    const eventPageEnum = this.theJob.type.toUpperCase() === "SELF"
      ? ToolbarEventPageEnum.JOB_SELF_SIGNING
      : ToolbarEventPageEnum.JOB_SIGN_REQUEST;

    if (result.isSuccess) {
      this.signingStatusService.stopPolling();
      this.handleMobileSigningSuccess(eventPageEnum);
    } else if (result.isRejected) {
      this.signingStatusService.stopPolling();
      this.handleMobileSigningRejected(eventPageEnum);
    } else if (result.status === SigningStatus.CERTIFICATE_EXPIRING_SOON) {
      this.signingStatusService.stopPolling();
      this.notificationService.certificateExpiringSoon();
      this.mobilSignErrororCancel("");
    } else if (result.isError) {
      this.signingStatusService.stopPolling();
      this.toolbarService.action(new ToolbarEvent(
        eventPageEnum, this.theJob.type, this.theJob.user.id,
        "WAITING", this.theJob.name, this.theJob.status, "", "", ""
      ));
      // The mobile-signing (msign) failure surfaces its code via
      // the status poll. When present, route it through displayError so the specific
      // localized message fires (e.g. case 304 TIMESTAMP_SERVICE_UNAVAILABLE); fall
      // back to the generic signingError when no code was reported.
      const pollErrorCode = result.errorCode ? Number(result.errorCode) : null;
      if (pollErrorCode) {
        this.notificationService.displayError({ code: pollErrorCode, description: result.errorDescription });
      } else {
        this.notificationService.signingError(this.theJob.name, result.status);
      }
      this.mobilSignErrororCancel("");
    } else if (result.status === 'TIMEOUT') {
      this.mobilSignErrororCancel("timeout");
    }
    // WAITING status - continue polling (handled by service)
  }

  /**
   * Handle successful mobile signing
   */
  private handleMobileSigningSuccess(eventPageEnum: ToolbarEventPageEnum): void {
    $("#myModal").modal('hide');

    if (!this.authorization.isInitializedAfterLogin()) {
      this.notificationService.showJobSigned(this.theRecipient.isRegistered, (isConfirmed: boolean) => {
        if (isConfirmed) {
          this.router.navigate(['/doc', this.theJob.id]);
        }
      });
    } else {
      this.notificationService.jobSigned(this.theJob.name);
      this.RedirectReferredPage();
    }

    if (this.theJob.type.toUpperCase() === "SELF") {
      this.notificationService.jobCompleted(this.theJob.name);
      this.toolbarService.action(new ToolbarEvent(
        eventPageEnum, this.theJob.type, this.theJob.user.id,
        "SIGNED", this.theJob.name, "COMPLETED", this.theJob.location, "", ""
      ));
    } else {
      this.toolbarService.action(new ToolbarEvent(
        eventPageEnum, this.theJob.type, this.theJob.user.id,
        "SIGNED", this.theJob.name, "", "", "", ""
      ));
    }
  }

  /**
   * Handle rejected mobile signing
   */
  private handleMobileSigningRejected(eventPageEnum: ToolbarEventPageEnum): void {
    $("#myModal").modal('hide');

    if (!this.authorization.isInitializedAfterLogin()) {
      this.notificationService.showJobRejected(this.theRecipient.isRegistered, (isConfirmed: boolean) => {
        if (isConfirmed) {
          this.router.navigate(['/doc', this.theJob.id]);
        }
      });
    } else {
      this.notificationService.jobRejected(this.theJob.name);
      this.RedirectReferredPage();
    }

    this.toolbarService.action(new ToolbarEvent(
      eventPageEnum, this.theJob.type, this.theJob.user.id,
      "DECLINED", this.theJob.name, "REJECTED", "", "", ""
    ));
  }

  // ============================================
  // Shared Digital Signer Modal Event Handlers
  // ============================================

  /**
   * Handle successful signing from shared digital signer modal
   */
  onSignComplete(result: SigningResult): void {
    console.log('Sign complete:', result);

    const eventPageEnum = this.theJob.type.toUpperCase() === "SELF"
      ? ToolbarEventPageEnum.JOB_SELF_SIGNING
      : ToolbarEventPageEnum.JOB_SIGN_REQUEST;

    // Log toolbar event
    if (this.theJob.type.toUpperCase() === "SELF") {
      this.notificationService.jobCompleted(this.theJob.name);
      this.toolbarService.action(new ToolbarEvent(
        eventPageEnum, this.theJob.type, this.theJob.user.id,
        "SIGNED", this.theJob.name, "COMPLETED", this.theJob.location, "", ""
      ));
    } else {
      this.toolbarService.action(new ToolbarEvent(
        eventPageEnum, this.theJob.type, this.theJob.user.id,
        "SIGNED", this.theJob.name, "", "", "", ""
      ));
    }

    // Handle navigation based on login state
    if (!this.authorization.isInitializedAfterLogin()) {
      this.notificationService.showJobSigned(this.theRecipient.isRegistered, (isConfirmed: boolean) => {
        if (isConfirmed) {
          this.router.navigate(['/doc', this.theJob.id]);
        }
      });
    } else {
      this.notificationService.jobSigned(this.theJob.name);
      this.RedirectReferredPage();
    }
  }

  /**
   * Handle cancellation from shared digital signer modal
   */
  onSignCancelled(): void {
    console.log('Sign cancelled');
    this.signingTerminated = true;
    this.signingStatusService.stopPolling();
    this.resetUsbSigningState();
    this.resetMobileSigningState();
  }

  /**
   * Handle rejection from shared digital signer modal
   */
  onSignRejected(): void {
    console.log('Sign rejected');

    const eventPageEnum = this.theJob.type.toUpperCase() === "SELF"
      ? ToolbarEventPageEnum.JOB_SELF_SIGNING
      : ToolbarEventPageEnum.JOB_SIGN_REQUEST;

    this.toolbarService.action(new ToolbarEvent(
      eventPageEnum, this.theJob.type, this.theJob.user.id,
      "DECLINED", this.theJob.name, "REJECTED", "", "", ""
    ));

    // Handle navigation based on login state
    if (!this.authorization.isInitializedAfterLogin()) {
      this.notificationService.showJobRejected(this.theRecipient.isRegistered, (isConfirmed: boolean) => {
        if (isConfirmed) {
          this.router.navigate(['/doc', this.theJob.id]);
        }
      });
    } else {
      this.notificationService.jobRejected(this.theJob.name);
      this.RedirectReferredPage();
    }
  }

  /**
   * Handle mobile sign error or cancel
   */
  mobilSignErrororCancel(source: string): void {
    this.signingStatusService.stopPolling();

    // Also stop legacy timer if it exists
    if (this.timerSubscription != null) {
      this.timerSubscription.unsubscribe();
    }

    if (source === "timeout") {
      this.notificationService.signingTimeout(this.theJob.name);
    }

    this.resetMobileSigningState();
  }

  /**
   * Reset mobile signing state
   */
  private resetMobileSigningState(): void {
    this.isMobilSignSecondPage = false;
    this.isSignDocumentClickedMobile = false;
    this.isMobilSignClicked = false;
    this.InitMobilFormData();
  }

  /**
   * Poll for signing status (legacy method, now uses SigningStatusService internally)
   * @deprecated Use startMobileSigningPolling instead
   */
  public RecipientRequestsCodeStatus(source: string): void {
    // This method is kept for backward compatibility
    // The new implementation uses SigningStatusService.startPolling()
    this.subscriptions.push(
      this.signingStatusService.checkStatus(this.requestCode).subscribe({
        next: (result: StatusPollResult) => {
          this.handleMobileSigningStatus(result);
        },
        error: (err) => {
          console.error("Status check error:", err);
          this.signingStatusService.stopPolling();
          $("#myModal").modal('hide');
          this.notificationService.displayError(err);
        }
      })
    );
  }

 goBack()
 {
   let self = this;
   let activeTab = $('ul#tabs li.active').text().trim();

   if(this.translate.instant(activeTab) == this.translate.instant("Mobile Sign")) {
     //turn first page and reset form
     if (this.isMobilSignSecondPage) {
       this.mobilSignErrororCancel("user cancelled");
     }
     else {
       cancelSign();
     }
   }

   if(this.translate.instant(activeTab) == this.translate.instant("Electronic Sign")) {
     cancelSign();
   }

   if(this.translate.instant(activeTab) == this.translate.instant("USB E-Signature")) {
     cancelSign();
   }


   function cancelSign(){
     self.signingTerminated = true;
     self.notificationService.showJobSigningCancelAlert(function(isConfirmed:boolean) {
       if(isConfirmed){
         self.SigningCalcel(isConfirmed);
         self.notificationService.jobCanceled(self.theJob.name);
       }
     });
   }

 }

  SigningCalcel(isConfirmed:boolean){

    if (isConfirmed) {
     $("#myModal").modal('hide');
     this.RedirectReferredPage();
   }

 }

  public RedirectReferredPage(){

    //console.log("Redirect Referred Page");
    //console.log("this.previousUrl")
    //if(this.returnUrl != ''){
    //  window.location.href = this.returnUrl;
      //console.log("this.returnUrl != '' this.returnUrl "+this.returnUrl);
    //}else{
      //this.location.back(); // çağıran sayfaya dönmek için
    let _thisRedirect = this;
    if(this.authorization.authenticated()) {
      setTimeout(function () {
        _thisRedirect.router.navigate(['/doc', _thisRedirect.theJob.id]);
      }, 2000);
    }
    else {
      setTimeout(function () {
        _thisRedirect.location.back();
      }, 2000);
    }
    //}
  }



  private onNavigationEvent(event:NavigationEvent) {
    switch (event.acton) {
      case "INCREMENT_ZOOM":
        this.incrementZoom(Number(event.value));
        break;
      case "REJECT_SIGN":
        this.RejectSign();
        break;
      case "APPROVE_SIGN":
      {
        this.ApproveSign();
        break;
      }
      case "OPEN_ATTACHMENTS":
      {
        this.attachmentsModalVisibility = true;
        setTimeout(() => { $('#attachmentsModal').modal('show'); }, 100);
        break;
      }
    }
   }

  incrementZoom(amount:number) {
    if(this.pdfLoading) {
      console.log("---> PDF or SHAPE(s) LOADING <---");
    } else {
      let newZoom = this.zoom + amount >= 0.2 ? this.zoom + amount : 0.2;

      if(this.zoom != newZoom) {
        this.zoom = newZoom;
      }
    }
  }


  RejectSign(){
    let _thisReject = this;
    this.notificationService.showJobSigningRejectAlert(function(isConfirmed:boolean) {
      if(isConfirmed)
      {
        _thisReject.subscriptions.push(_thisReject.recipientRequestApi.recipientRequestsCodeRejectPost(_thisReject.requestCode).subscribe(
          (response:any) => {
            if(response.code == 200)
            {
              _thisReject.toolbarService.action(new ToolbarEvent(ToolbarEventPageEnum.JOB_SIGN_REQUEST, _thisReject.theJob.type , _thisReject.theJob.user.id,  "DECLINED", _thisReject.theJob.name, "REJECTED", "", "", ""));

              //without login
              if(!_thisReject.authorization.isInitializedAfterLogin()) {
                _thisReject.notificationService.showJobRejected(_thisReject.theRecipient.isRegistered, function (isConfirmed: boolean) {
                  if (isConfirmed) {
                    _thisReject.router.navigate(['/doc', _thisReject.theJob.id])
                  }
                });
              //with login
              }else{
                _thisReject.notificationService.jobRejected(_thisReject.theJob.name);
                _thisReject.router.navigate(['/doc', _thisReject.theJob.id]);
              }
            }

          }, //Bind to view
          (err:any) => {
            // Log errors if any
            console.log(err);
            _thisReject.notificationService.displayError(err);
          }
        ));

      }
    });
  }

  async ApproveSign(){
    // Refuse to sign while the disclosure is outstanding.
    //
    // This is not belt-and-braces, it IS the gate. Withholding getDocFields() stops a signer
    // clicking a field overlay, but Approve lives in the navbar and needs no fields at all — and
    // the validation below iterates the recipient's fields, which the gate leaves EMPTY, so every required
    // field passes vacuously and the document is signed with no consent recorded. Deferring the
    // fields made Approve easier rather than harder.
    //
    // Decline is deliberately NOT guarded: the disclosure tells a signer to withdraw by
    // declining, so that route has to stay open.
    if (this.disclosureGateOpen) {
      this.notificationService.disclosureNotAccepted();
      return;
    }

    // Sync HTML form field values from formFieldValues to field.value before validation
    this.syncHtmlFormFieldsToSubmission();

    this.fillAlertShapes = [];
    let isValidationOK: boolean = true;

    // The gate now shares its emptiness rules with the filling helper's counter, so the
    // two can never disagree. fillAlertShapes is still populated per FIELD, as before (a radio
    // group contributes one entry per unsatisfied option); the counter counts the group once.
    for (const field of this.currentRecipientFields) {
      if (!this.filling.isCountable(field, this.theRecipient.id)) { continue; }

      if (this.filling.isUnfilled(field, this.formFieldValues, this.currentRecipientFields)) {
        isValidationOK = false;
        this.fillAlertShapes.push(field);
      }
    }

    let self = this;
    if (isValidationOK) {
      //alert if document already rejected
      if (self.theJob.status == "REJECTED") {
        let byWhom: string = self.isRequestCodeUsed ? "you" : "others";
        self.notificationService.documentAlreadyRejected(byWhom);
      } else {
        // Subscribe to saveShapes and wait for async operation to complete
        self.subscriptions.push(
          self.saveShapes().subscribe(
            (response: any) => {
              console.log("change(s) saved...");
              // Use the detected signature type for the recipient
              if(self.recipientSignatureType === "bio" || self.recipientSignatureType === "initials"){
                self.signByBiometricSignature();
              } else {
                // Show shared digital signer modal
                if (self.digitalSignerModal) {
                  self.digitalSignerModal.showModal();
                } else {
                  // Fallback to jQuery for backwards compatibility
                  $("#myModal").modal('show');
                }
              }
            },
            (err: any) => {
              // Log errors if any
              console.log(err);
              self.notificationService.displayError(err);
            }
          )
        );
      }

    } else {
      console.error("Required fields should be filled. Empty fileds: ", self.fillAlertShapes);
      self.refreshCanvasSubject.next("true");

      // Leave the signer looking at the first field the gate is actually complaining
      // about, instead of only a message that names nothing. Same predicate that just built
      // fillAlertShapes, so the two can never point at different fields.
      const first = self.filling.firstOutstandingStop(
        self.fillingStops, self.formFieldValues, self.currentRecipientFields);

      if(self.theJob.type.toUpperCase() == "SELF"){
        // Blocking modal — jump once it has been dismissed, or the scroll happens behind it.
        self.notificationService.showMandatoryFieldsNotFilled(function (isConfirmed: boolean) {
          if (first) { self.goToStop(first); }
        })
      } else {
        // Non-blocking toast — jump straight away.
        self.notificationService.mandatoryFieldsNotFilled();
        if (first) { self.goToStop(first); }
      }
    }
  }

  signByBiometricSignature(){
    let self = this;
    self.notificationService.showWantToSignBioSign(function (isConfirmed: boolean) {
      if (isConfirmed) {

        if(self.theRecipient.smsRequired != "" && self.theRecipient.smsRequired != null && self.recipientSignatureType === "bio"){ // SMS Verification is Active
          self.showSmsVerificationModal();
        } else {
          self.bioSignatureApiCall();
        }
      }
    });
  }

  async bioSignatureApiCall(smsCode?:string){
    let self = this;
    self.subscriptions.push(self.recipientRequestApi.recipientRequestsCodeBiosignPost(self.requestCode, self.authorization.getAccessToken(), smsCode).subscribe(
      (response:any) => {
        console.log(response);

        this.closeSmsVerificationModal();

        let eventPageEnum:ToolbarEventPageEnum = self.theJob.type.toUpperCase() == "SELF" ? ToolbarEventPageEnum.JOB_SELF_SIGNING : ToolbarEventPageEnum.JOB_SIGN_REQUEST;

        if(self.theJob.type.toUpperCase() == "SELF"){
          self.notificationService.jobCompleted(self.theJob.name);
          self.toolbarService.action(new ToolbarEvent(eventPageEnum, self.theJob.type , self.theJob.user.id, "SIGNED", self.theJob.name, "COMPLETED", self.theJob.location, "", ""));
        }else {
          self.toolbarService.action(new ToolbarEvent(eventPageEnum, self.theJob.type, self.theJob.user.id, "SIGNED", self.theJob.name, "", "", "", ""));
        }

        //self.RecipientRequestsCodeStatus("bio-sign");
        //without login
        if(!self.authorization.isInitializedAfterLogin()) {
          self.notificationService.showJobSigned(self.theRecipient.isRegistered, function (isConfirmed: boolean) {
            if (isConfirmed) {
              self.router.navigate(['/doc', self.theJob.id])
            }
          });
          //with login
        }else{
          self.notificationService.jobSigned(self.theJob.name);
          self.RedirectReferredPage();
        }

      }, //Bind to view
      (error:any) => {
        console.log(error);
        let errorObject = JSON.parse(error._body)
        if(errorObject.code == 263){
          this.notificationService.showSmsPasswordExpired();
        } else if(errorObject.code == 264) {
          this.notificationService.showSmsPasswordIncorrect();
        } else {
          this.notificationService.displayError(error);
        }
      }
    ));
  }

  isEmpty(str:string) {
    return (!str || 0 === str.length);
  }

  initFormOverlay() {
    const self = this;

    // Create form overlays using ngx-extended-pdf-viewer's annotation capabilities
    this.createFormElements();

    // Subscribe to navigation changes
    this.refreshCanvasSubject.subscribe((value: any) => {
      this.updateFormElementPositions();
    });

  }

  createFormElements() {
    // Create form elements as overlays on the PDF
    this.docFields.forEach((field: any, index: number) => {
      this.createFormElement(field, index);
    });
  }

  createFormElement(field: any, index: number) {
    const enabled = this.theRecipient.id == field.recipientId && field.enabled !== 'false';

    // Create form element based on type
    switch (field.type) {
      case 'bio-sign':
      case 'sign-area':
        this.createSignatureField(field, enabled);
        break;
      case 'initials':
        this.createInitialsField(field, enabled);
        break;
    }
  }

  createSignatureField(field: any,  enabled: boolean) {
    // Implementation for signature field
    if (enabled) {
      // Show signature capture modal when clicked
      console.log('Creating signature field for field:', field.id);
    }
  }

  createInitialsField(field: any, enabled: boolean) {
    // Implementation for initials field
    if (enabled) {
      // Show initials capture modal when clicked
      console.log('Creating initials field for field:', field.id);
    }
  }

  updateFormElementPositions() {
    // Update form element positions based on current zoom and scroll
    // Note: onPageRendered will be called automatically when zoom changes,
    // which will recreate overlays with correct dimensions
    console.log('Updating form element positions');
  }

  onZoomChanged(zoomFactor: number) {
    console.log('PDF viewer zoom changed to:', zoomFactor);
    this.zoom = zoomFactor;

    // Recreate HTML form field overlays for all visible pages
    if (this.fieldsLoaded) {
      setTimeout(() => {
        // Recreate overlays for each page that has them
        this.htmlFormOverlays.forEach((overlay, pageNumber) => {
          const pageDiv = document.querySelector(`.page[data-page-number="${pageNumber}"]`) as HTMLElement;
          // Get the MAIN page canvas (not annotation widget canvases)
          const canvas = pageDiv?.querySelector('canvas[role="presentation"]') as HTMLCanvasElement;
          if (canvas) {
            this.createHtmlOverlayForPage(pageNumber, canvas);
            // Create HTML signature overlays for this page
            this.createSignatureOverlayForPage(pageNumber, canvas);
          }
        });

        // Also recreate signature overlays for pages that don't have form fields
        this.htmlSignatureOverlays.forEach((overlay, pageNumber) => {
          if (!this.htmlFormOverlays.has(pageNumber)) {
            const pageDiv = document.querySelector(`.page[data-page-number="${pageNumber}"]`) as HTMLElement;
            // Get the MAIN page canvas (not annotation widget canvases)
            const canvas = pageDiv?.querySelector('canvas[role="presentation"]') as HTMLCanvasElement;
            if (canvas) {
              this.createSignatureOverlayForPage(pageNumber, canvas);
            }
          }
        });
      }, 100);
    }

    // Note: ngx-extended-pdf-viewer will fire pageRendered events after zoom,
    // which will recreate the overlays with correct dimensions
  }

  updateFormElementColors(color: string) {
    // Update form element colors based on selected recipient
    console.log('Updating form element colors to:', color);
  }

  //color code to rgba for transparent convertion
  hexToRGBA(hex:any, opacity:any) {
    if(opacity == "1.0")
      return hex;

    return 'rgba(' + (hex = hex.replace('#', '')).match(new RegExp('(.{' + hex.length/3 + '})', 'g')).map(function(l:any) { return parseInt(hex.length%2 ? l+l : l, 16) }).concat(opacity||1).join(',') + ')';
  }

  // Update all signature overlays with the stored signature image
  updateAllSignatureOverlays() {
    if (!this.recipientSignatureImage) return;

    const decodedImage = decodeURIComponent(this.recipientSignatureImage);

    // Update all signed fields for this recipient
    this.docFields.forEach((field: any) => {
      if ((field.type === 'bio-sign' || field.type === 'initials') &&
          field.recipientId == this.theRecipient.id &&
          field.value === "true") {
        this.updateOrCreateSignatureImage(field, decodedImage);
      }
    });
  }

  // Update existing or create new signature image (HTML-based)
  updateOrCreateSignatureImage(field: any, imageData: string) {
    // Use the new HTML-based displaySignatureImage method
    this.displaySignatureImage(field.id, imageData);
  }

  // Create new signature image on canvas
  // NOTE: Fabric.js method - disabled in favor of HTML signature overlays
  // async createSignatureImage(field: any, imageData: string) {
  // const pageNumber = field.page;
  // const overlay = this.signatureOverlays.get(field.id);
  // const fabricCanvas = this.fabricCanvases.get(pageNumber);
  //   // if (!overlay || !fabricCanvas) return;
  //     // Check if imageData already contains the data URL prefix
  // const imageUrl = imageData.startsWith('data:image') ? imageData : `data:image/png;base64,${imageData}`;
  //   // console.log('Creating signature image for field:', field.id);
  // console.log('Image URL prefix:', imageUrl.substring(0, 50));
  //   // try {
  // const img = await fabric.FabricImage.fromURL(imageUrl);
  // console.log('Image loaded successfully for field:', field.id);
  //       // Get the current zoom level and device pixel ratio
  // const currentZoom = this.zoom || 1;
  // const devicePixelRatio = window.devicePixelRatio || 1;
  //       // Calculate field dimensions with zoom
  // const fieldWidth = field.width * currentZoom;
  // const fieldHeight = field.height * currentZoom;
  //       // Calculate scale to fit the image in the field with padding
  // const padding = 5 * currentZoom;
  // const availableWidth = fieldWidth - (padding * 2);
  // const availableHeight = fieldHeight - (padding * 2);
  //       // Calculate scale while preserving aspect ratio
  // const scaleX = availableWidth / img.width;
  // const scaleY = availableHeight / img.height;
  // const scale = Math.min(scaleX, scaleY) * 0.9; // Use 90% of available space
  //   // img.scale(scale);
  //       // Center the image in the field
  // const scaledWidth = img.width * scale;
  // const scaledHeight = img.height * scale;
  // img.set({
  // left: overlay.left + (fieldWidth - scaledWidth) / 2,
  // top: overlay.top + (fieldHeight - scaledHeight) / 2,
  // selectable: false,
  // evented: false,
  // perPixelTargetFind: false  // Ensure image doesn't block clicks
  // });
  //       // Hide the placeholder but keep for click detection
  // const objects = overlay.getObjects();
  // if (objects[0]) objects[0].set('opacity', 0.01);
  // if (objects[1]) objects[1].set('visible', true);
  //       // Add image to the overlay group instead of directly to canvas
  // overlay.add(img);
  // this.signatureImageObjects.set(field.id, img);
  //       // Ensure the group remains interactive
  // overlay.set({
  // subTargetCheck: true,
  // perPixelTargetFind: false
  // });
  //   // fabricCanvas.renderAll();
  // } catch (error) {
  // console.error('Failed to load image for field:', field.id, error);
  // }
  // }

  /** The capture modes the page offers, as the values the API records. */
  private static readonly CAPTURE_MODES: { [selection: string]: string } = {
    draw: 'drawn',
    upload: 'image',
    styles: 'styles',
    list: 'reused'
  };

  /** The mode currently selected in the capture modal, or '' if it is not one we record. */
  private selectedCaptureMode(): string {
    return SigningComponent.CAPTURE_MODES[this.bioSignSelection] || '';
  }

  /**
   * The body of a signature upload.
   *
   * Every caller goes through here so the mode cannot be attached to some of them and not others.
   * Five places post to this endpoint — two for signatures, two for initials, and the one that
   * applies an already-captured image to a second box — and a signer with more than one box is
   * the normal case, so a mode added to the obvious call would be missing exactly when it is
   * most needed. The parameter is omitted entirely rather than sent empty when there is no mode
   * to report: the server records nothing for an absent value, which is the honest answer.
   */
  private signatureUploadBody(fieldId: any, fileData: string, mode: string): string {
    const body = "fieldId=" + fieldId + "&fileData=" + fileData;
    return mode ? body + "&signatureMode=" + encodeURIComponent(mode) : body;
  }

  // Apply existing signature to unsigned field
  applyExistingSignatureToField(field: any) {
    const xhr = new XMLHttpRequest();
    const params = this.signatureUploadBody(field.id, this.recipientSignatureImage, this.recipientSignatureMode);

    xhr.open('POST', Config.WEBSERVICEURL + '/recipient_signatures/' + this.requestCode);
    if (this.authorization.isInitializedAfterLogin()) {
      xhr.setRequestHeader('access_token', String(this.authorization.getAccessToken()));
    }
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

    xhr.onload = () => {
      if(xhr.status === 200) {
        // Mark field as signed
        field.value = "true";

        // Create signature image for this field
        this.displaySignatureImage(field.id, decodeURIComponent(this.recipientSignatureImage));

        // Remove from fillAlertShapes if present
        const index = this.fillAlertShapes.findIndex((x: any) => x.id == field.id);
        if(index !== -1) {
          this.fillAlertShapes.splice(index, 1);
        }
      }
    };

    xhr.send(params);
  }

  saveShapes(): Observable<any> {
    console.log("========== SAVE SHAPES - FIELD SUBMISSION ==========");

    // Prepare fields for submission
    let fieldsToSubmit:any = this.currentRecipientFields.map((field: any) => {
      return { ...field };
    });

    // Log what we're submitting
    console.log("Fields being submitted to server:");
    fieldsToSubmit.forEach((field: any) => {
      if (field.type === 'text-input' || field.type === 'checkbox' || field.type === 'radio') {
        console.log(`  [${field.type.toUpperCase()}] ID: ${field.id}, Label: "${field.label}", Value: "${field.value}"`);
      } else if (field.type === 'bio-sign' || field.type === 'initials' || field.type === 'sign-area') {
        console.log(`  [${field.type.toUpperCase()}] ID: ${field.id}, Signed: ${field.value === "true"}`);
      }
    });

    let json: string = JSON.stringify(fieldsToSubmit);
    console.log("JSON payload size:", json.length, "characters");
    console.log("====================================================");

    return this.fieldsApi.recipientRequestsCodeFieldsPut(this.requestCode, json);
  }

  /**
   * Validates uploaded image file type and size
   */
  private validateImageFile(file: File): { valid: boolean; error?: string } {
    // Check file extension
    const isValidType = (/\.(jpg|jpeg|png)$/i).test(file.name);
    if (!isValidType) {
      return {
        valid: false,
        error: this.translate.instant("File extensions should be one of png, jpg, jpeg")
      };
    }

    // Check file size
    const isJPEG = (/\.(jpg|jpeg)$/i).test(file.name);
    const maxSizeBytes = isJPEG ? this.MAX_JPEG_SIZE_KB * 1024 : this.MAX_PNG_SIZE_KB * 1024;

    if (file.size > maxSizeBytes) {
      const errorKey = isJPEG
        ? "JPG type file size should be at most 500 KB"
        : "File size should be at most 1 MB";
      return {
        valid: false,
        error: this.translate.instant(errorKey)
      };
    }

    return { valid: true };
  }

  /**
   * Validates image dimensions
   */
  private validateImageDimensions(width: number, height: number): boolean {
    return width >= this.MIN_IMAGE_WIDTH && height >= this.MIN_IMAGE_HEIGHT;
  }

  /**
   * Scales and centers image on canvas
   */
  private scaleAndCenterImage(img: HTMLImageElement): { canvas: HTMLCanvasElement; imageData: ImageData } {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d")!;
    canvas.width = this.SIGNATURE_CANVAS_WIDTH;
    canvas.height = this.SIGNATURE_CANVAS_HEIGHT;

    // Calculate scaled dimensions
    const sizes = this.getScaledImageSizes(img.width, img.height);

    // Center the image on canvas
    const x = canvas.width / 2 - sizes.width / 2;
    const y = canvas.height / 2 - sizes.height / 2;
    context.drawImage(img, x, y, sizes.width, sizes.height);

    const imageData = context.getImageData(0, 0, this.SIGNATURE_CANVAS_WIDTH, this.SIGNATURE_CANVAS_HEIGHT);

    return { canvas, imageData };
  }

  /**
   * Shows error in upload view and as Swal notification
   */
  private showUploadError(errorMessage: string): void {
    this.uploadError = errorMessage;
    this.notificationService.displayError(new Error(errorMessage));
    this.resetUploadView();
  }

  showSignature(event: any) {
    // Reset state
    this.signatureFile = null;
    this.uploadError = "";
    this.scaledImage = { canvas: null, sizes: { width: 0, height: 0 }, imageData: null }; // Fixed typo: imageDate -> imageData

    if (!event.target.files || event.target.files.length === 0) {
      return;
    }

    const file: File = event.target.files[0];
    console.log("Processing uploaded file:", file.name);

    // Validate file type and size
    const validation = this.validateImageFile(file);
    if (!validation.valid) {
      this.showUploadError(validation.error!);
      return;
    }

    // Create object URL for image loading
    const img: HTMLImageElement = document.getElementById('output') as HTMLImageElement;
    const objectUrl = URL.createObjectURL(file);
    img.src = objectUrl;

    // Handle image loading
    img.onload = () => {
      try {
        const width = img.naturalWidth || img.width;
        const height = img.naturalHeight || img.height;

        // Validate dimensions
        if (!this.validateImageDimensions(width, height)) {
          const errorMsg = this.translate.instant("File width should be at least 300px and the height at least 200px.");
          this.showUploadError(errorMsg);
          return;
        }

        // Set the file
        this.signatureFile = file;
        console.log("Image validated successfully:", { width, height, size: file.size });

        // Scale and center image
        const result = this.scaleAndCenterImage(img);
        this.scaledImage.canvas = result.canvas;
        this.scaledImage.imageData = result.imageData;

        // Calculate scaled sizes for display
        const sizes = this.getScaledImageSizes(width, height);
        this.scaledImage.sizes.width = sizes.width;
        this.scaledImage.sizes.height = sizes.height;

        // Update image display size
        img.style.width = sizes.width + 'px';
        img.style.height = sizes.height + 'px';

      } catch (error) {
        console.error("Error processing image:", error);
        const errorMsg = this.translate.instant("Error occurred in process. Please check file type, size, width and height properties.");
        this.showUploadError(errorMsg);
      } finally {
        // Revoke object URL to prevent memory leak
        URL.revokeObjectURL(objectUrl);
      }
    };

    img.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      const errorMsg = this.translate.instant("Error occurred in process. Please check file type, size, width and height properties.");
      this.showUploadError(errorMsg);
    };
  }

  clearSignaturePad(){
    this.signaturePad.clear();
  }

  useSignature(){

    if(this.bioSignSelection == "list"){
      let tmpB64String = encodeURIComponent(this.signatureListSelection);
      this.uploadSignature(tmpB64String);

    } else if(this.bioSignSelection == "draw") {

      //let data:any = this.signaturePad.toDataURL("image/svg+xml"); // save image as SVG
      let data:any = this.signaturePad.toDataURL(); // save image as PNG
      //console.log(data);
      //console.log(atob(data.split(',')[1]));

      let tmpB64String = encodeURIComponent(data);
      this.uploadSignature(tmpB64String);

    } else if(this.bioSignSelection == "upload") {

      // create a destination canvas. Here the altered image will be placed
      let dstCanvas:any = document.createElement("canvas");
      dstCanvas.width = this.scaledImage.canvas.width;
      dstCanvas.height = this.scaledImage.canvas.height;

      // get context to work with
      let dstContext:any = dstCanvas.getContext("2d");

      // read pixels from source
      let pixels:any = this.scaledImage.imageData;
      let newColor:any = { r:0, g:0, b:0, a:0 };

      // iterate through pixel data (1 pixels consists of 4 ints in the array)
      for(let i = 0, len = pixels.data.length; i < len; i += 4){
        let r = pixels.data[i];
        let g = pixels.data[i+1];
        let b = pixels.data[i+2];

        if (r >= 225 && g >= 225 && b >= 225 ) {
          pixels.data[i] = newColor.r;
          pixels.data[i+1] = newColor.g;
          pixels.data[i+2] = newColor.b;
          pixels.data[i+3] = newColor.a;
        }

      }

      // write pixel data to destination context
      dstContext.putImageData(pixels,0,0);

      let tmpB64String = encodeURIComponent(dstCanvas.toDataURL("image/png"));

      this.uploadSignature(tmpB64String);
    } else if(this.bioSignSelection == "styles"){
      let c:any = document.getElementById("stylesCanvas");
      let tmpB64String = encodeURIComponent(c.toDataURL("image/png"));
      this.uploadSignature(tmpB64String);
      this.stylesInput = "";
      this.updateStylesCanvas();
    } else {
      console.error("unknown tab index")
    }

  }

  getScaledImageSizes(srcWidth:number, srcHeight:number):any {
    let maxWidth:number = 600, // max width
      maxHeight:number = 200; // max height

    let ratio:number = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);

    return { width: Math.round(srcWidth*ratio), height: Math.round(srcHeight*ratio) };
  }

  base64MimeType(base64Image:string):any {
    let result:any = null;

    if (this.isEmpty(base64Image)) {
      return result;
    }

    let mime:any = base64Image.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);

    if (mime && mime.length) {
      result = mime[1];
    }

    return result;
 }

  uploadSignature(tmpB64String:any,updateAll:boolean = true){
    // Resolved once here, while the selection still reflects what the signer just did.
    const captureMode = this.selectedCaptureMode();
    let self = this;
    let xhr = new XMLHttpRequest();

    let filledBioSigns:Array<any> = [];
    self.docFields.forEach(
      (element:any) => {
        if(element.id != self.selectedField.id && element.type == "bio-sign" && element.value == "true" && element.recipientId == self.theRecipient.id){
          filledBioSigns.push(element);
        }
      }
    );

    if(filledBioSigns.length > 0 && updateAll){
      filledBioSigns.push(self.selectedField);

      (function doXHR(index:number,length:number){
        if(index>=length){
          $("#bioSignModal").modal('hide');
          self.resetUploadView();

          // Store the signature image after all updates complete
          self.recipientSignatureImage = tmpB64String;
          self.recipientSignatureMode = captureMode;

          // Update all signature overlays with the new image
          self.updateAllSignatureOverlays();

          self.refreshCanvasSubject.next("true");
          console.log("All signatures are updated");
          return;
        }

        let element = filledBioSigns[index];
        let params = self.signatureUploadBody(element.id, tmpB64String, captureMode);
        xhr.open('POST', Config.WEBSERVICEURL + '/recipient_signatures/' + self.requestCode);
        xhr.upload.addEventListener("progress", function(e:any){
          if (e.lengthComputable) {
            console.log("Uploaded:..." + e.loaded + "/" + e.total);
          }
        }, false);
        if(self.authorization.isInitializedAfterLogin()){
          xhr.setRequestHeader('access_token', String(self.authorization.getAccessToken()));
        }
        xhr.setRequestHeader('Content-Type',  'application/x-www-form-urlencoded');
        xhr.send(params);

        xhr.onload = function() {
          if(xhr.status == 200) {

            console.log("The transfer is complete for id = " + element.id);

            if(self.fillAlertShapes.length > 0) {
              console.log(self.fillAlertShapes.length);
              self.fillAlertShapes.splice(self.fillAlertShapes.indexOf(element), 1);
              console.log(self.fillAlertShapes.length);
            }

            doXHR(index+1,length);

          } else {
            self.resetUploadView();

            self.docFields[self.docFields.indexOf(element)].value = ""; //reset field
            let index: any = self.fillAlertShapes.findIndex((x: any) => x.id == element.id);

            if(index == -1){
              self.fillAlertShapes.push(element);
              console.log(self.fillAlertShapes);
            }

            setTimeout(function () {
              self.refreshCanvasSubject.next("true");
            },100);

            self.notificationService.signatureImageIsNotAppropriate();
          }

        };
      })(0,filledBioSigns.length);

    } else {

      let params = self.signatureUploadBody(self.selectedField.id, tmpB64String, captureMode);

      xhr.onload = function() {
        if(xhr.status == 200) {

          console.log("The transfer is complete.");
          $("#bioSignModal").modal('hide');

          self.resetUploadView();

          self.docFields[self.docFields.indexOf(self.selectedField)].value = "true"; //set 'true' to show field setted

          // Store the signature image for reuse
          self.recipientSignatureImage = tmpB64String;
          self.recipientSignatureMode = captureMode;

          if(self.fillAlertShapes.length > 0) {
            console.log(self.fillAlertShapes.length);
            self.fillAlertShapes.splice(self.fillAlertShapes.indexOf(self.selectedField), 1);

            console.log(self.fillAlertShapes.length);
          }

          // Update all signature overlays with the new image
          self.updateAllSignatureOverlays();

          self.refreshCanvasSubject.next("true");

        } else {
          self.resetUploadView();

          self.docFields[self.docFields.indexOf(self.selectedField)].value = ""; //reset field
          let index: any = self.fillAlertShapes.findIndex((x: any) => x.id == self.selectedField.id);

          if(index == -1){
            self.fillAlertShapes.push(self.selectedField);
            console.log(self.fillAlertShapes);
          }

          self.refreshCanvasSubject.next("true");

          self.notificationService.signatureImageIsNotAppropriate();
        }

      };

      xhr.open('POST', Config.WEBSERVICEURL + '/recipient_signatures/' + self.requestCode);

      xhr.upload.addEventListener("progress", function(e:any){
        if (e.lengthComputable) {
          //self.cloudFile.progress = ((e.loaded / e.total) *100 ).toString().split('.')[0];
          console.log("Uploaded:..." + e.loaded + "/" + e.total);
        }
      }, false);

      if(this.authorization.isInitializedAfterLogin()){
        xhr.setRequestHeader('access_token', String(this.authorization.getAccessToken()));
      }
      xhr.setRequestHeader('Content-Type',  'application/x-www-form-urlencoded');

      // Send the data
      xhr.send(params);

    }

  }


  resetUploadView(){
    //reset upload view
    this.signatureFile = null;
    this.initialsFile = null;
    this.clearSignaturePad();

  }

  showSmsVerificationModal(){
    let currentTimestamp = new Date().getTime();
    let recipientSmsTimestamp = this.theRecipient.smsSent;
    let validTime =  currentTimestamp - +recipientSmsTimestamp

    if(validTime >= this.smsVerificationTimeConstant*1000){
      this.subscriptions.push(
        this.recipientRequestApi.recipientRequestsCodeResendsmsPut(
          this.requestCode
        ).subscribe(
          (response:any) => {
            if(response.success == true){
              this.theRecipient.smsSent = response.sentDate;
              this.smsVerificationTime = this.smsVerificationTimeConstant;
              this.initSmsModal();
            } else {
              console.log(response.errorCode);
              this.notificationService.errorOccuredInServer();
            }
          },
          (error:any) => {
            this.notificationService.displayError(error);
          }
        )
      );
    } else {
      this.smsVerificationTime = Math.floor((this.smsVerificationTimeConstant*1000 - validTime) / 1000)
      this.initSmsModal();
    }

  }

  initSmsModal(){
    $("#smsVerificationModal").modal('show');
    let smsVerificationMinutes;
    let smsVerificationSeconds;
    let smsResendMinutes;
    let smsResendSeconds;
    if(this.smsVerificationTime <= (this.smsVerificationTimeConstant - this.smsResendTimeConstant)){
      this.smsResendTime = 0;
    } else {
      this.smsResendTime = this.smsResendTimeConstant - (this.smsVerificationTimeConstant - this.smsVerificationTime);
    }

    this.smsVerificationTimerObject = interval(1000).subscribe(x => {

      this.smsVerificationTime--;
      smsVerificationSeconds = Math.floor(this.smsVerificationTime % 60);
      smsVerificationMinutes = Math.floor(this.smsVerificationTime / 60);
      if(smsVerificationSeconds <= 9){
        this.smsVerificationTimeText = smsVerificationMinutes + ":0" + smsVerificationSeconds
      } else {
        this.smsVerificationTimeText = smsVerificationMinutes + ":" + smsVerificationSeconds
      }
      if(this.smsVerificationTime == 0){
        this.disableSmsVerify = true;
        this.smsVerificationTimerObject.unsubscribe();
        let self = this;
        this.notificationService.showSmsTimedOutAlert(function (isConfirmed: boolean) {
          if (isConfirmed) {
            self.resendSmsCode();
          } else {
            self.closeSmsVerificationModal();
            self.RedirectReferredPage();
          }
        })
      }

      if(this.smsResendTime > 0){
        this.smsResendTime--;
        smsResendSeconds = Math.floor(this.smsResendTime % 60);
        smsResendMinutes = Math.floor(this.smsResendTime / 60);
        if(smsResendSeconds <= 9){
          this.smsResendTimeText = smsResendMinutes + ":0" + smsResendSeconds;
        } else {
          this.smsResendTimeText = smsResendMinutes + ":" + smsResendSeconds;
        }
        if(this.smsResendTime == 0){
          this.disableResendSMSButton = false;
        }
      } else {
        this.disableResendSMSButton = false;
      }

    });
  }

  resendSmsCode(){
    this.subscriptions.push(
      this.recipientRequestApi.recipientRequestsCodeResendsmsPut(
        this.requestCode
      ).subscribe(
        (response:any) => {
          if(response.success == true){
            this.theRecipient.smsSent = response.sentDate;
            this.smsVerificationTime = this.smsVerificationTimeConstant;
            this.smsResendTime = this.smsResendTimeConstant;
            this.disableResendSMSButton = true;
            this.disableSmsVerify = false;
            this.closeSmsVerificationModal();
            setTimeout(()=>{ this.initSmsModal(); }, 1000);
          } else {
            this.notificationService.errorOccuredInServer();
          }
        },
        (error:any) => {
          console.log(error);
          this.notificationService.displayError(error);
        }
      )
    )
  }

  closeSmsVerificationModal(){
    $("#smsVerificationModal").modal('hide');
    if(this.smsVerificationTimerObject != null){
      this.smsVerificationTimerObject.unsubscribe();
    }
  }

  private makeImageTransparent(scaledImage: any): string {
    const dstCanvas: any = document.createElement("canvas");
    dstCanvas.width = scaledImage.canvas.width;
    dstCanvas.height = scaledImage.canvas.height;
    const dstContext: any = dstCanvas.getContext("2d");
    const pixels: any = scaledImage.imageData;
    const newColor: any = { r: 0, g: 0, b: 0, a: 0 };

    for (let i = 0, len = pixels.data.length; i < len; i += 4) {
      const r = pixels.data[i];
      const g = pixels.data[i + 1];
      const b = pixels.data[i + 2];
      if (r >= 225 && g >= 225 && b >= 225) {
        pixels.data[i] = newColor.r;
        pixels.data[i + 1] = newColor.g;
        pixels.data[i + 2] = newColor.b;
        pixels.data[i + 3] = newColor.a;
      }
    }

    dstContext.putImageData(pixels, 0, 0);
    return encodeURIComponent(dstCanvas.toDataURL("image/png"));
  }


  useInitials(){
    console.log("using initials:",this.bioSignSelection);
    switch(this.bioSignSelection){
      case "list":{
        let tmpB64String = encodeURIComponent(this.signatureListSelection);
        this.uploadInitials(tmpB64String);
      } break;
      case "draw":{
        let data:any = this.signaturePad.toDataURL();
        let tmpB64String = encodeURIComponent(data);
        this.uploadInitials(tmpB64String);
      } break;
      case "upload":{
        // create a destination canvas. Here the altered image will be placed
        let tmpB64String = this.makeImageTransparent(this.scaledImage);
        this.uploadInitials(tmpB64String);
      } break;
      case "styles":{
        let c:any = document.getElementById("stylesCanvas");
        let tmpB64String = encodeURIComponent(c.toDataURL("image/png"));
        this.uploadInitials(tmpB64String);
        this.stylesInput = "";
        this.updateStylesCanvas();
      } break;
      default: {
        console.error("tab index unknown")
      } break;
    }
  }

  uploadInitials(tmpB64String:any,updateAll:boolean=true){
    // Resolved once here, while the selection still reflects what the signer just did.
    const captureMode = this.selectedCaptureMode();
    let self = this;
    let xhr = new XMLHttpRequest();

    let filledInitials:Array<any> = [];
    self.docFields.forEach(
      (element:any) => {
        if(element.id != self.selectedField.id && element.type == "initials" && element.value == "true" && element.recipientId == self.theRecipient.id){
          filledInitials.push(element);
        }
      }
    );

    if(filledInitials.length > 0 && updateAll){
      filledInitials.push(self.selectedField);
      console.log(filledInitials);

      (function doXHR(index:number,length:number){
        if(index>=length){
          $("#bioSignModal").modal('hide');
          self.resetUploadView();

          // Store the signature image after all updates complete
          self.recipientSignatureImage = tmpB64String;
          self.recipientSignatureMode = captureMode;

          // Update all signature overlays with the new image
          self.updateAllSignatureOverlays();

          self.refreshCanvasSubject.next("true");
          console.log("All signatures are updated");
          return;
        }

        let element = filledInitials[index];
        let params = self.signatureUploadBody(element.id, tmpB64String, captureMode);
        xhr.open('POST', Config.WEBSERVICEURL + '/recipient_signatures/' + self.requestCode);
        xhr.upload.addEventListener("progress", function(e:any){
          if (e.lengthComputable) {
            console.log("Uploaded:..." + e.loaded + "/" + e.total);
          }
        }, false);
        if(self.authorization.isInitializedAfterLogin()){
          xhr.setRequestHeader('access_token', String(self.authorization.getAccessToken()));
        }
        xhr.setRequestHeader('Content-Type',  'application/x-www-form-urlencoded');
        xhr.send(params);

        xhr.onload = function() {
          if(xhr.status == 200) {

            console.log("The transfer is complete for id = " + element.id);

            if(self.fillAlertShapes.length > 0) {
              console.log(self.fillAlertShapes.length);
              self.fillAlertShapes.splice(self.fillAlertShapes.indexOf(element), 1);
              console.log(self.fillAlertShapes.length);
            }

            doXHR(index+1,length);

          } else {
            self.resetUploadView();

            self.docFields[self.docFields.indexOf(element)].value = ""; //reset field
            let index: any = self.fillAlertShapes.findIndex((x: any) => x.id == element.id);

            if(index == -1){
              self.fillAlertShapes.push(element);
              console.log(self.fillAlertShapes);
            }

            setTimeout(function () {
              self.refreshCanvasSubject.next("true");
            },100);

            self.notificationService.signatureImageIsNotAppropriate();
          }

        };
      })(0,filledInitials.length);

    } else {
      let params = self.signatureUploadBody(self.selectedField.id, tmpB64String, captureMode);

      xhr.onload = function() {
        if(xhr.status == 200) {

          console.log("The transfer is complete.");
          $("#bioSignModal").modal('hide');

          self.resetUploadView();
          self.docFields[self.docFields.indexOf(self.selectedField)].value = "true"; //set 'true' to show field setted

          // Store the signature image for reuse
          self.recipientSignatureImage = tmpB64String;
          self.recipientSignatureMode = captureMode;

          if(self.fillAlertShapes.length > 0) {
            console.log(self.fillAlertShapes.length);
            self.fillAlertShapes.splice(self.fillAlertShapes.indexOf(self.selectedField), 1);
            console.log(self.fillAlertShapes.length);
          }

          // Update all signature overlays with the new image
          self.updateAllSignatureOverlays();

          self.refreshCanvasSubject.next("true");

        } else {
          self.resetUploadView();

          self.docFields[self.docFields.indexOf(self.selectedField)].value = ""; //reset field
          let index: any = self.fillAlertShapes.findIndex((x: any) => x.id == self.selectedField.id);

          if(index == -1){
            self.fillAlertShapes.push(self.selectedField);
            console.log(self.fillAlertShapes);
          }

          self.refreshCanvasSubject.next("true");

          self.notificationService.signatureImageIsNotAppropriate();
        }

      };

      xhr.open('POST', Config.WEBSERVICEURL + '/recipient_signatures/' + self.requestCode);

      xhr.upload.addEventListener("progress", function(e:any){
        if (e.lengthComputable) {
          console.log("Uploaded:..." + e.loaded + "/" + e.total);
        }
      }, false);

      if(this.authorization.isInitializedAfterLogin()){
        xhr.setRequestHeader('access_token', String(this.authorization.getAccessToken()));
      }

      xhr.setRequestHeader('Content-Type',  'application/x-www-form-urlencoded');
      xhr.send(params);
    }

  }

  showInitials(event:any){
    this.initialsFile = null;
    this.uploadError = "";
    this.scaledImage = { canvas:null, sizes: { width: 0, height: 0 }, imageDate:null };
    let self = this;

    if(event.target.files.length > 0) {
      let files: any = event.target.files;

      let match = (/\.(jpg|jpeg|png)$/i).test(files[0].name);
      console.log("file type match: " + match);

      if (match) {
        let isImageSizeAppropriate:boolean = true;

        let isFileJPEG:boolean = (/\.(jpg|jpeg)$/i).test(files[0].name);
        //console.log("Size", files[0].size/1024, " KB")

        if(isFileJPEG){
          isImageSizeAppropriate = files[0].size <= 500 * 1024;
        } else {
          isImageSizeAppropriate = files[0].size <= 1024 * 1024;
        }

        if (isImageSizeAppropriate) {

          let img: any = document.getElementById('output');
          img.src = URL.createObjectURL(event.target.files[0]);

          let width: number, height: number;

          img.onload = function () {
            width = img.naturalWidth || img.width;
            height = img.naturalHeight || img.height;

            if (width >= 300 && height >= 200) {
              self.initialsFile = files[0];
              console.log(files[0]);

              //Get 1*3 ratio for 200*600 image size
              let sizes:any = self.getScaledImageSizes(width, height);
              self.scaledImage.sizes.width = sizes.width;
              self.scaledImage.sizes.height = sizes.height;

              img.style.width = sizes.width + 'px';
              img.style.height = sizes.height + 'px';

              let canvas:any=document.createElement("canvas");
              let context:any=canvas.getContext("2d");
              canvas.width=600;
              canvas.height=200;

              let x:number= canvas.width/2 - img.width/2;
              let y:number= canvas.height/2 - img.height/2;
              context.drawImage(img, x, y, img.width, img.height);

              self.scaledImage.canvas = canvas;
              self.scaledImage.imageData = context.getImageData(0, 0, 600, 200);
            } else {
              self.resetUploadView();
              self.uploadError = self.translate.instant("File width should be at least 300px and the height at least 200px.");
            }
          };

        } else {
          if(isFileJPEG){
            self.uploadError = self.translate.instant("JPG type file size should be at most 500 KB");
          } else {
            self.uploadError = self.translate.instant("File size should be at most 1 MB");
          }
        }
      } else {
        self.uploadError = self.translate.instant("File extensions should be one of png, jpg, jpeg");
      }
    }
  }

  changeFont(goNext:boolean){
    if(goNext){
      if(this.stylesFontIndex == this.stylesFonts.length - 1){
        return;
      } else {
        this.stylesFontIndex++;
      }
    } else {
      if(this.stylesFontIndex == 0){
        return;
      } else {
        this.stylesFontIndex--;
      }
    }
    this.updateStylesCanvas();
  }

  updateStylesCanvas(){
    let c:any = document.getElementById("stylesCanvas");
    let ctx:CanvasRenderingContext2D = c.getContext("2d");
    c.width = 300;
    c.height = 200;
    ctx.clearRect(0, 0, c.width, c.height);
    let fontSize:number;
    let heightFromTop;

    if(this.stylesInput.length > 5 && this.stylesInput.length <= 8){
      fontSize = 50;
      heightFromTop = c.height*6/10;
    } else if(this.stylesInput.length > 8 && this.stylesInput.length <= 12){
      fontSize = 40;
      heightFromTop = c.height*11/20;
    } else if(this.stylesInput.length > 12 && this.stylesInput.length <= 16){
      if(this.stylesInput == this.stylesInput.toUpperCase()){
        fontSize = 25;
      } else {
        fontSize = 30;
      }
      heightFromTop = c.height*21/40;
    } else if(this.stylesInput.length > 16 && this.stylesInput.length <= 20){
      if(this.stylesInput == this.stylesInput.toUpperCase()){
        fontSize = 20;
      } else {
        fontSize = 25;
      }
      heightFromTop = c.height*21/40;
    } else {
      fontSize = 80 - 5*this.stylesInput.length;
      heightFromTop = c.height*7/12;
    }

    ctx.font =  fontSize + "px" + " " + this.stylesFonts[this.stylesFontIndex];
    ctx.textAlign = 'center';
    ctx.fillText(this.stylesInput, 150, heightFromTop);
  }

  getRecipientInitials(){
    let recipientName:Array<String> = this.theRecipient.name.split(" ");
    let initials:string = "";
    recipientName.forEach((element:string) => {
      initials += element.charAt(0);
    });
    this.stylesInput = initials.toUpperCase();
    this.updateStylesCanvas();
  }

  loadRecipientAttachmentCount(toolbarEvent?: ToolbarEvent): void {
    this.attachmentsApi.recipientRequestsCodeAttachmentsGet(this.requestCode).subscribe(
      (response: Communication.AttachmentListResponse) => {
        this.attachmentCount = response.count || 0;
        // Emit a new toolbar event with attachment count so navbar can show badge
        if (toolbarEvent && this.attachmentCount > 0) {
          let updatedEvent = new ToolbarEvent(
            toolbarEvent.page, toolbarEvent.jobType, toolbarEvent.jobOwnerId,
            toolbarEvent.recipientState, toolbarEvent.title, toolbarEvent.value,
            toolbarEvent.location, toolbarEvent.sharePublicLink, toolbarEvent.isDownloadAllowed
          );
          updatedEvent.attachmentCount = this.attachmentCount;
          this.toolbarService.action(updatedEvent);
        }
      },
      (err) => { console.error('Error loading attachments:', err); }
    );
  }

  onAttachmentsClosed(): void {
    this.attachmentsModalVisibility = false;
  }

  ngOnDestroy() {

    // Unregister PDF viewer from control service
    this.pdfViewerControl.unregisterPdfViewer();

    // Remove Bootstrap modal event listeners
    $('#bioSignModal').off('shown.bs.modal');
    $('#bioSignModal').off('hidden.bs.modal');

    $('.modal-backdrop').remove(); //browser ileri-geri tuşuna basıncaki kırıklığı önlemek

    // Dispose of all Fabric canvases
    this.fabricCanvases.forEach((canvas, pageNumber) => {
      console.log(`Disposing Fabric canvas for page ${pageNumber}`);
      canvas.dispose();
    });
    this.fabricCanvases.clear();

    // Remove all HTML form field overlays
    this.htmlFormOverlays.forEach((overlay, pageNumber) => {
      console.log(`Removing HTML overlay for page ${pageNumber}`);
      overlay.remove();
    });
    this.htmlFormOverlays.clear();

    // Clear overlays map
    this.signatureOverlays.clear();

    this.subscriptions.forEach(
      (s:Subscription) => s.unsubscribe()
    );
    if (this.timerSubscription != null) {
      this.timerSubscription.unsubscribe();
    }
    if (this.smsVerificationTimerObject != null){
      this.smsVerificationTimerObject.unsubscribe();
    }
  }

  public get pdfFormData(): { [fieldName: string]: string | number | boolean } {
    const formData: { [fieldName: string]: string | number | boolean } = {};

    // Only process current recipient's form fields
    this.currentRecipientFields.forEach((field: any) => {
      if (field.type === 'text-input' || field.type === 'checkbox' || field.type === 'radio') {
        const fieldName = field.variable || field.label || `field_${field.id}`;

        if (field.type === 'checkbox') {
          formData[fieldName] = field.value === 'true' || field.value === true;
        } else if (field.type === 'radio') {
          // Handle radio groups
          if (field.value === 'true') {
            formData[field.variable || fieldName] = field.options || field.label;
          }
        } else {
          formData[fieldName] = this.formFieldValues[field.id] || field.value || '';
        }
      }
    });

    return formData;
  }

  public set pdfFormData(data: { [fieldName: string]: string | number | boolean }) {
    // Update form field values when PDF form changes
    this.currentRecipientFields.forEach((field: any) => {
      if (field.type === 'text-input' || field.type === 'checkbox' || field.type === 'radio') {
        const fieldName = field.variable || field.label || `field_${field.id}`;

        if (data[fieldName] !== undefined) {
          this.formFieldValues[field.id] = data[fieldName];
          // Update the field value for API submission
          field.value = String(data[fieldName]);
        }
      }
    });

    // Write to PDF.js for ng2-pdf-viewer
    this.writeFormFieldsToPdf(data);
  }

  // Event handler for one-way formData binding
  onFormDataChange(data: { [fieldName: string]: string | number | boolean }) {
    this.pdfFormData = data;
  }

  /**
   * Read form field values from PDF.js (ng2-pdf-viewer)
   * Returns a dictionary mapping field IDs to their current values
   */
  async readFormFieldsFromPdf(): Promise<{ [fieldId: string]: any }> {
    if (!this.ng2PdfDocument) {
      console.warn("readFormFieldsFromPdf: PDFDocument not available");
      return {};
    }

    try {
      const formData: { [fieldId: string]: any } = {};

      // Get field definitions from PDF
      const fieldObjects = await this.ng2PdfDocument.getFieldObjects();

      if (!fieldObjects) {
        console.warn("No form fields found in PDF");
        return {};
      }

      // Get current field values from annotation storage
      const annotationStorage = this.ng2PdfDocument.annotationStorage;
      const allValues = annotationStorage ? annotationStorage.getAll() : {};

      console.log("PDF Field Objects:", fieldObjects);
      console.log("Annotation Storage Values:", allValues);

      // Iterate through all fields and get their values
      for (const [fieldName, fieldArray] of Object.entries(fieldObjects)) {
        if (Array.isArray(fieldArray) && fieldArray.length > 0) {
          const field = fieldArray[0]; // Get first field instance

          // Try to get value from annotation storage first
          let value = null;
          if (allValues[field.id]) {
            value = allValues[field.id].value;
          } else if (field.value !== undefined) {
            // Fall back to field's default value
            value = field.value;
          }

          if (value !== null && value !== undefined) {
            formData[fieldName] = value;
            console.log(`Field "${fieldName}" (${field.type}):`, value);
          }
        }
      }

      console.log("Read form data from PDF:", formData);
      return formData;
    } catch (error) {
      console.error("Error reading form fields from PDF:", error);
      return {};
    }
  }

  /**
   * Write form field values to PDF.js (ng2-pdf-viewer)
   * @param formData Dictionary mapping field names to values
   */
  async writeFormFieldsToPdf(formData: { [fieldName: string]: any }): Promise<void> {
    if (!this.ng2PdfDocument) {
      console.warn("writeFormFieldsToPdf: PDFDocument not available");
      return;
    }

    try {
      const annotationStorage = this.ng2PdfDocument.annotationStorage;
      if (!annotationStorage) {
        console.warn("Annotation storage not available");
        return;
      }

      // Get field definitions to map field names to field IDs
      const fieldObjects = await this.ng2PdfDocument.getFieldObjects();
      if (!fieldObjects) {
        console.warn("No form fields found in PDF");
        return;
      }

      console.log("Writing form data to PDF:", formData);

      // Iterate through formData and set values in annotation storage
      for (const [fieldName, value] of Object.entries(formData)) {
        if (fieldObjects[fieldName] && Array.isArray(fieldObjects[fieldName]) && fieldObjects[fieldName].length > 0) {
          const field = fieldObjects[fieldName][0];

          try {
            // Set value in annotation storage
            annotationStorage.setValue(field.id, { value: value });
            console.log(`Set field "${fieldName}" (ID: ${field.id}) to:`, value);
          } catch (fieldError) {
            console.error(`Error setting field "${fieldName}":`, fieldError);
          }
        }
      }

      console.log("Form fields written to PDF successfully");
    } catch (error) {
      console.error("Error writing form fields to PDF:", error);
    }
  }

  /**
   * Capture filled form field values from PDF before signing
   * Updates application state with current PDF form values
   */
  async captureFormFieldsBeforeSigning(): Promise<void> {
    console.log("Capturing form field values before signing...");

    try {
      // Read current form field values from PDF
      const pdfFormData = await this.readFormFieldsFromPdf();

      if (Object.keys(pdfFormData).length === 0) {
        console.log("No form field values to capture");
        return;
      }

      // Map PDF field names to our application's field IDs using FormElementService
      const updatedValues = this.formElementService.syncPdfFormDataToFields(
        this.currentRecipientFields,
        pdfFormData
      );

      // Merge the returned values with existing formFieldValues
      Object.assign(this.formFieldValues, updatedValues);

      console.log("Form field values captured successfully");
      console.log("Updated formFieldValues:", this.formFieldValues);
    } catch (error) {
      console.error("Error capturing form field values:", error);
    }
  }

  /**
   * Sync HTML form field values from formFieldValues to field.value before submission
   * HTML overlays update formFieldValues in real-time via event listeners
   * This method ensures those values are properly synced to field.value for API submission
   */
  // =====================================
  // Filling helper
  // =====================================

  /** Built once, after the fields load. The set does not change during a signing session. */
  buildFillingStops(): void {
    this.fillingStops = this.filling.buildStops(this.currentRecipientFields, this.theRecipient.id);
    console.log(`Filling helper: ${this.fillingStops.length} stop(s)`);
  }

  /** The bar is not rendered when there is nothing to walk — e.g. a QES signer whose only field
   *  is a sign-area, which is never a traversal stop. */
  get hasFillingStops(): boolean {
    return this.fillingStops.length > 0;
  }

  /**
   * Outstanding mandatory stops.
   *
   * Bound as a METHOD in the template, so change detection re-evaluates it every cycle and it
   * cannot go stale. That is deliberate: a cached number would need every mutation site wired up,
   * and a missed one is exactly how a counter drifts away from the Approve gate. The cost is a
   * loop over the signer's fields per cycle, which is tens of string comparisons.
   */
  remainingMandatory(): number {
    return this.filling.remainingMandatory(
      this.fillingStops, this.formFieldValues, this.currentRecipientFields);
  }

  onFillingStart(): void {
    const first = this.filling.nextStop(this.fillingStops, null, this.formFieldValues, this.currentRecipientFields);
    if (first) { this.goToStop(first); }
  }

  onFillingNext(): void {
    const next = this.filling.nextStop(
      this.fillingStops, this.currentStop(), this.formFieldValues, this.currentRecipientFields);
    if (next) { this.goToStop(next); }
  }

  onFillingPrevious(): void {
    const previous = this.filling.previousStop(
      this.fillingStops, this.currentStop(), this.formFieldValues, this.currentRecipientFields);
    if (previous) { this.goToStop(previous); }
  }

  private currentStop(): FillingStop | null {
    if (!this.currentStopKey) { return null; }
    return this.fillingStops.find((s) => s.key === this.currentStopKey) || null;
  }

  private stopWrapper(stop: FillingStop): HTMLElement | null {
    return document.querySelector(`[data-field-id="${stop.anchorFieldId}"]`) as HTMLElement | null;
  }

  /**
   * Navigate to a stop: scroll it into view, highlight it, and focus its input.
   *
   * If the stop's page has not rendered yet it has no overlay element to land on, so we scroll to
   * the page div (PDF.js creates those up front with show-all) and leave the navigation PENDING.
   * applyHighlightForPage finishes it when that page's overlay is built. Without this, navigating
   * to an unrendered page is a silent no-op.
   */
  goToStop(stop: FillingStop): void {
    this.fillingStarted = true;
    this.clearFillingHighlight();
    this.currentStopKey = stop.key;

    const wrapper = this.stopWrapper(stop);
    if (wrapper) {
      this.pendingStopKey = null;
      wrapper.classList.add('filling-helper-active');
      this.scrollFieldIntoSafeView(wrapper);
      this.focusStop(stop, wrapper);
      return;
    }

    this.pendingStopKey = stop.key;
    const pageDiv = document.querySelector(`.page[data-page-number="${stop.page}"]`) as HTMLElement | null;
    if (pageDiv) {
      this.scrollFieldIntoSafeView(pageDiv);
    }
    // If even the page div is missing we keep pendingStopKey and wait — rendering it will fire
    // onPageRendered, which rebuilds the overlay and calls applyHighlightForPage.
  }

  /**
   * The one hook that keeps the highlight correct. Called at the tail of BOTH overlay builders,
   * which is what makes it cover every case that destroys or creates overlay elements:
   *
   *  - a page rendering lazily      (onPageRendered -> builders)
   *  - a zoom change, which tears the overlays down and rebuilds them (onZoomChanged -> builders)
   *
   * The highlight is re-applied every time. Scroll and focus run ONLY when the navigation is
   * still pending, so a zoom rebuild cannot yank the viewport or steal focus from the signer.
   */
  applyHighlightForPage(pageNumber: number): void {
    const stop = this.currentStop();
    if (!stop || Number(stop.page) !== Number(pageNumber)) { return; }

    const wrapper = this.stopWrapper(stop);
    if (!wrapper) { return; }

    wrapper.classList.add('filling-helper-active');

    if (this.pendingStopKey === stop.key) {
      this.pendingStopKey = null;
      this.scrollFieldIntoSafeView(wrapper);
      this.focusStop(stop, wrapper);
      return;
    }

    // Not a pending navigation, so do not scroll. But the rebuild just destroyed the element the
    // signer was typing in: scrolling to a stop makes PDF.js render newly-visible pages, which
    // rebuilds this overlay moments after we focused it, and focus falls back to <body>. Restore
    // it — but only when nothing else has taken it, so this can never pull focus away from a
    // field the signer chose themselves.
    const active = document.activeElement;
    if (!active || active === document.body) {
      this.focusStop(stop, wrapper);
    }
  }

  private clearFillingHighlight(): void {
    document.querySelectorAll('.filling-helper-active')
      .forEach((el: Element) => el.classList.remove('filling-helper-active'));
  }

  /**
   * Scroll so the element is centred in the part of the viewport the helper bar cannot cover.
   *
   * scrollIntoView({block:'center'}) centres in the whole viewport, which on a short screen puts
   * the field under the bottom-docked bar — the thing the bar must never do.
   */
  private scrollFieldIntoSafeView(el: HTMLElement): void {
    const scroller = el.closest('.ng2-pdf-viewer-container') as HTMLElement | null;
    if (!scroller) {
      el.scrollIntoView({ block: 'center', behavior: 'smooth' });
      return;
    }

    const bar = document.querySelector('.filling-helper-bar') as HTMLElement | null;
    // Only a bottom-docked bar eats vertical space; the desktop pill floats clear of the content.
    const barHeight = bar && window.innerWidth <= 768 ? bar.offsetHeight : 0;
    const safeHeight = Math.max(scroller.clientHeight - barHeight, el.offsetHeight);

    const delta = (el.getBoundingClientRect().top - scroller.getBoundingClientRect().top)
                - (safeHeight - el.offsetHeight) / 2;

    scroller.scrollTo({ top: scroller.scrollTop + delta, behavior: 'smooth' });
  }

  /**
   * Focus the landed-on field so the signer can type or toggle immediately.
   *
   * bio-sign and initials share ONE branch and are never focused or clicked: scroll and highlight
   * only. The signature modal opens from the overlay's own click listener, and the helper must
   * never trigger it. (If these two ever need separate branches, the initials path stops being
   * covered by the bio-sign E2E and needs its own — see docs/design/signing-component.md.)
   */
  private focusStop(stop: FillingStop, wrapper: HTMLElement): void {
    if (SIGNATURE_STOP_TYPES.indexOf(stop.type) !== -1) { return; }

    const input = wrapper.querySelector('input') as HTMLInputElement | null;
    if (!input) { return; }

    input.focus({ preventScroll: true });
    if (stop.type === 'text-input') {
      input.select();
    }
    // checkbox / radio are focused only — the helper never chooses a value for the signer.
  }

  syncHtmlFormFieldsToSubmission(): void {
    console.log("Syncing HTML form field values to submission...");
    console.log("Current formFieldValues state:", this.formFieldValues);

    let syncCount = 0;

    // The value rules now live in exactly one place, FillingHelperService.resolveValue,
    // which is also what the counter and the Approve gate read. Before this, the live value of a
    // radio group reached field.value only here, at Approve time, so anything reading field.value
    // earlier saw every group as unanswered.
    this.currentRecipientFields.forEach((field: any) => {
      if (field.type !== 'text-input' && field.type !== 'checkbox' && field.type !== 'radio') {
        return;
      }

      const resolved = this.filling.resolveValue(field, this.formFieldValues, this.currentRecipientFields);
      if (resolved === undefined) {
        // Nothing in formFieldValues for this field — leave field.value alone, as before.
        return;
      }

      field.value = resolved;
      syncCount++;
      console.log(`  [${field.type.toUpperCase()}] Field ${field.id} ("${field.label}"): ${field.value}`);
    });

    console.log(`Synced ${syncCount} form field values for submission`);
  }

  // Performance optimization: trackBy function for signature list
  trackBySignature(index: number, signature: string): string {
    return signature;
  }

  // Computed getter for repeated condition in signing modal tabs
  get isSigningDisabled(): boolean {
    return this.isMobilSignSecondPage || this.isMobilSignClicked;
  }

  // Computed getter for bio-sign "Use" button disable condition
  get isBioUseDisabled(): boolean {
    return (this.bioSignSelection == 'styles' && this.stylesInput.length <= 0) ||
           (this.bioSignSelection == 'list' && !this.signatureListSelection);
  }

  // =====================================
  // HTML Form Field Overlay Methods (Per-Page Architecture)
  // =====================================

  /**
   * Create HTML form field overlay for a specific page
   * Follows the same pattern as createOverlaysForPage() for Fabric.js canvases
   */
  createHtmlOverlayForPage(pageNumber: number, pdfCanvas: HTMLCanvasElement, retryCount: number = 0): void {
    // ✅ Read canvas viewport dimensions ONCE for all fields on this page
    // Use clientWidth/clientHeight (content area only, excluding border) to match form-designer
    const canvasWidth = pdfCanvas.clientWidth;
    const canvasHeight = pdfCanvas.clientHeight;

    if (canvasWidth < 100 || canvasHeight < 100) {
      console.warn(`Canvas for page ${pageNumber} has invalid dimensions (${canvasWidth}x${canvasHeight}), retry ${retryCount}`);

      // Retry up to 5 times with increasing delays
      if (retryCount < 5) {
        setTimeout(() => {
          this.createHtmlOverlayForPage(pageNumber, pdfCanvas, retryCount + 1);
        }, 100 * (retryCount + 1)); // Exponential backoff: 100ms, 200ms, 300ms, etc.
        return;
      } else {
        console.error(`Failed to create HTML overlay for page ${pageNumber} after ${retryCount} retries - canvas dimensions still invalid`);
        return;
      }
    }

    console.log(`Creating HTML form overlay for page ${pageNumber} with dimensions ${canvasWidth}x${canvasHeight}`);

    // Remove existing overlay if present
    if (this.htmlFormOverlays.has(pageNumber)) {
      const existing = this.htmlFormOverlays.get(pageNumber);
      existing?.remove();
      this.htmlFormOverlays.delete(pageNumber);
    }

    // Find the page container (.page div) which has position: relative
    const pageContainer = pdfCanvas.closest('.page') ||
                         pdfCanvas.closest('[data-page-number]') ||
                         pdfCanvas.parentElement;

    if (!pageContainer) {
      console.error(`Cannot find page container for page ${pageNumber}`);
      return;
    }

    // Get fields for THIS page only
    const pageFields = this.currentRecipientFields.filter(
      (f: any) => Number(f.page) === pageNumber &&
      (f.type === 'text-input' || f.type === 'checkbox' || f.type === 'radio')
    );

    if (pageFields.length === 0) {
      console.log(`No form fields for page ${pageNumber}`);
      return;
    }

    // Create overlay container div
    const overlayDiv = document.createElement('div');
    overlayDiv.id = `html-form-overlay-${pageNumber}`;
    overlayDiv.className = 'html-form-overlay-container';
    overlayDiv.style.position = 'absolute';
    overlayDiv.style.top = '0';
    overlayDiv.style.left = '0';
    overlayDiv.style.width = canvasWidth + 'px';
    overlayDiv.style.height = canvasHeight + 'px';
    overlayDiv.style.pointerEvents = 'none'; // Pass-through by default
    overlayDiv.style.zIndex = '99'; // Below fabric canvas (100) but above PDF
    overlayDiv.style.overflow = 'visible';

    // Create and position each field
    pageFields.forEach((field: any) => {
      const fieldElement = this.createFieldElement(field, pdfCanvas);
      if (fieldElement) {
        overlayDiv.appendChild(fieldElement);
      }
    });

    // Append to page container
    pageContainer.appendChild(overlayDiv);

    // Store reference
    this.htmlFormOverlays.set(pageNumber, overlayDiv);

    console.log(`Created HTML overlay with ${pageFields.length} fields for page ${pageNumber}`);

    // The elements the highlight lives on were just replaced. Re-apply it (and finish a
    // pending navigation, if this is the page it was waiting for).
    this.applyHighlightForPage(pageNumber);
  }

  /**
   * Create a field element (wrapper + input) for a specific field
   */
  private createFieldElement(field: any, pdfCanvas: HTMLCanvasElement): HTMLElement | null {
    // Calculate screen position from PDF coordinates (use clientWidth to match form-designer)
    const viewport = {
      width: pdfCanvas.clientWidth,
      height: pdfCanvas.clientHeight
    };

    // ✅ Extract actual page dimensions from PDF viewer DOM (not hardcoded!)
    const pageWrapper = pdfCanvas.closest('[data-page-number]');
    if (!pageWrapper) {
      console.error('❌ Could not find page wrapper for field', field.id);
      return null;
    }
    const pageDimensions = this.extractPageDimensions(pageWrapper);

    const screenCoords = this.pdfToScreen(field, viewport, pageDimensions);

    // Create wrapper div
    const wrapper = document.createElement('div');
    wrapper.className = 'form-field-wrapper';
    wrapper.setAttribute('data-field-id', field.id);
    wrapper.style.position = 'absolute';
    wrapper.style.left = screenCoords.x + 'px';
    wrapper.style.top = screenCoords.y + 'px';
    wrapper.style.width = screenCoords.width + 'px';
    wrapper.style.height = screenCoords.height + 'px';
    wrapper.style.pointerEvents = 'auto'; // Enable interaction
    wrapper.style.boxSizing = 'border-box';

    // Create input element based on type
    let inputElement: HTMLElement | null = null;

    if (field.type === 'text-input') {
      inputElement = this.createTextInput(field, screenCoords.height);
    } else if (field.type === 'checkbox') {
      inputElement = this.createCheckbox(field, screenCoords.height);
    } else if (field.type === 'radio') {
      inputElement = this.createRadio(field, screenCoords.height);
    }

    if (inputElement) {
      wrapper.appendChild(inputElement);
      return wrapper;
    }

    return null;
  }

  /**
   * Create text input element with event binding
   */
  private createTextInput(field: any, screenHeight: number): HTMLInputElement {
    const input = document.createElement('input');
    input.type = 'text';
    input.value = this.formFieldValues[field.id] || field.value || '';
    input.placeholder = field.label || '';

    // Dynamic font size based on screen height
    const baseFontSize = 13;
    const baseHeight = 30;
    const scaledFontSize = Math.max(10, Math.min(32, (screenHeight / baseHeight) * baseFontSize));

    // Apply all styles inline — Angular ViewEncapsulation.Emulated scopes CSS classes
    // so they won't apply to dynamically created DOM elements
    input.style.cssText = `
      width: 100%; height: 100%; box-sizing: border-box; margin: 0;
      padding: 1px 2px; font-family: Arial, sans-serif; font-size: ${scaledFontSize}px;
      line-height: 1; border: 1px solid #ccc; border-radius: 0;
      background: rgba(255, 255, 255, 0.95); display: block; pointer-events: auto;
    `;

    if (field.required) input.required = true;
    if (!field.enabled) {
      input.readOnly = true;
      input.style.background = 'rgba(240, 240, 240, 0.9)';
      input.style.borderColor = '#ccc';
      input.style.color = '#666';
    }

    // Event listeners
    input.addEventListener('input', (e) => {
      const target = e.target as HTMLInputElement;
      this.formFieldValues[field.id] = target.value;
      field.value = target.value;
    });

    input.addEventListener('change', (e) => {
      console.log(`Text field changed: ${field.id}`, this.formFieldValues[field.id]);
    });

    return input;
  }

  /**
   * Create checkbox element (no label, just checkbox)
   */
  private createCheckbox(field: any, screenHeight: number): HTMLInputElement {
    const input = document.createElement('input');
    input.type = 'checkbox';
    input.checked = this.formFieldValues[field.id] === true || this.formFieldValues[field.id] === 'true';

    // Apply all styles inline (Angular encapsulation won't apply scoped CSS to dynamic elements)
    input.style.cssText = `
      width: 100%; height: 100%; box-sizing: border-box; margin: 0;
      pointer-events: auto; cursor: pointer;
    `;

    if (field.required) input.required = true;
    if (!field.enabled) input.disabled = true;

    // Event listener
    input.addEventListener('change', (e) => {
      const target = e.target as HTMLInputElement;
      this.formFieldValues[field.id] = target.checked;
      field.value = String(target.checked);
      console.log(`Checkbox changed: ${field.id}`, target.checked);
    });

    return input;
  }

  /**
   * Create radio button element (no label, just radio button)
   */
  private createRadio(field: any, screenHeight: number): HTMLInputElement {
    const input = document.createElement('input');
    input.type = 'radio';
    input.name = field.variable || `radio-${field.id}`;
    input.value = field.id.toString();

    // Apply all styles inline (Angular encapsulation won't apply scoped CSS to dynamic elements)
    input.style.cssText = `
      width: 100%; height: 100%; box-sizing: border-box; margin: 0;
      pointer-events: auto; cursor: pointer;
    `;

    // Check if this radio is selected based on group value (stored field ID)
    const groupName = field.variable || `radio-${field.id}`;
    const selectedFieldId = this.formFieldValues[groupName];
    if (selectedFieldId === field.id.toString()) {
      input.checked = true;
    }

    if (field.required) input.required = true;
    if (!field.enabled) input.disabled = true;

    // Event listener
    input.addEventListener('change', (e) => {
      const target = e.target as HTMLInputElement;
      if (target.checked) {
        // Store selected field ID by group name
        const groupName = field.variable || `radio-${field.id}`;
        this.formFieldValues[groupName] = field.id.toString();
        console.log(`Radio group "${groupName}" selected field ${field.id} (${field.label})`);
      }
    });

    return input;
  }

  /**
   * Destroy HTML overlay for a specific page
   */
  destroyHtmlOverlayForPage(pageNumber: number): void {
    if (this.htmlFormOverlays.has(pageNumber)) {
      const overlay = this.htmlFormOverlays.get(pageNumber);
      overlay?.remove();
      this.htmlFormOverlays.delete(pageNumber);
      console.log(`Destroyed HTML overlay for page ${pageNumber}`);
    }
  }

  // =====================================
  // HTML Signature Overlay Methods (Replaces Fabric.js)
  // =====================================

  /**
   * Create HTML signature overlay for a specific page
   * Replaces Fabric.js canvas with HTML divs for signature fields
   */
  createSignatureOverlayForPage(pageNumber: number, pdfCanvas: HTMLCanvasElement, retryCount: number = 0): void {
    // Use clientWidth/clientHeight (content area only, excluding border) to match form-designer
    const canvasWidth = pdfCanvas.clientWidth;
    const canvasHeight = pdfCanvas.clientHeight;

    if (canvasWidth < 100 || canvasHeight < 100) {
      console.warn(`Canvas for page ${pageNumber} has invalid dimensions (${canvasWidth}x${canvasHeight}), retry ${retryCount}`);

      // Retry up to 5 times with increasing delays
      if (retryCount < 5) {
        setTimeout(() => {
          this.createSignatureOverlayForPage(pageNumber, pdfCanvas, retryCount + 1);
        }, 100 * (retryCount + 1)); // Exponential backoff: 100ms, 200ms, 300ms, etc.
        return;
      } else {
        console.error(`Failed to create HTML signature overlay for page ${pageNumber} after ${retryCount} retries - canvas dimensions still invalid`);
        return;
      }
    }

    console.log(`Creating HTML signature overlay for page ${pageNumber} with dimensions ${canvasWidth}x${canvasHeight}`);

    // Remove existing overlay if present
    if (this.htmlSignatureOverlays.has(pageNumber)) {
      const existing = this.htmlSignatureOverlays.get(pageNumber);
      existing?.remove();
      this.htmlSignatureOverlays.delete(pageNumber);
    }

    // Find the page container (.page div) which has position: relative
    const pageContainer = pdfCanvas.closest('.page') ||
                         pdfCanvas.closest('[data-page-number]') ||
                         pdfCanvas.parentElement;

    if (!pageContainer) {
      console.error(`Cannot find page container for page ${pageNumber}`);
      return;
    }

    // Get signature fields for THIS page (all recipients)
    const allPageFields = this.fieldsByPage.get(pageNumber) || [];
    const signatureFields = allPageFields.filter(
      (f: any) => f.type === 'sign-area' || f.type === 'bio-sign' || f.type === 'initials'
    );

    if (signatureFields.length === 0) {
      console.log(`No signature fields for page ${pageNumber}`);
      return;
    }

    // Create overlay container div
    const overlayDiv = document.createElement('div');
    overlayDiv.id = `html-signature-overlay-${pageNumber}`;
    overlayDiv.className = 'html-signature-overlay-container';
    overlayDiv.style.position = 'absolute';
    overlayDiv.style.top = '0';
    overlayDiv.style.left = '0';
    overlayDiv.style.width = canvasWidth + 'px';
    overlayDiv.style.height = canvasHeight + 'px';
    overlayDiv.style.pointerEvents = 'none'; // Pass-through by default
    overlayDiv.style.zIndex = '100'; // Same as fabric canvas was
    overlayDiv.style.overflow = 'visible';

    // Create and position each signature field
    signatureFields.forEach((field: any) => {
      const fieldElement = this.createSignatureFieldElement(field, pdfCanvas);
      if (fieldElement) {
        overlayDiv.appendChild(fieldElement);
      }

      // If already signed, show image
      if (field.value === "true" && this.recipientSignatureImage) {
        setTimeout(() => {
          this.displaySignatureImage(field.id, decodeURIComponent(this.recipientSignatureImage));
        }, 100);
      }
    });

    // Add disabled overlays for other recipients' form fields (non-signature)
    const otherFormFields = allPageFields.filter((f: any) =>
      Number(f.recipientId) !== this.theRecipient.id &&
      (f.type === 'text-input' || f.type === 'checkbox' || f.type === 'radio')
    );

    otherFormFields.forEach((field: any) => {
      const disabledOverlay = this.createDisabledFieldOverlay(field, pdfCanvas);
      if (disabledOverlay) {
        overlayDiv.appendChild(disabledOverlay);
      }
    });

    // Append to page container
    pageContainer.appendChild(overlayDiv);

    // Store reference
    this.htmlSignatureOverlays.set(pageNumber, overlayDiv);

    console.log(`Created HTML signature overlay with ${signatureFields.length} signature fields for page ${pageNumber}`);

    // Same hook as the form overlay: a bio-sign / initials stop is highlighted here.
    this.applyHighlightForPage(pageNumber);
  }

  /**
   * Create a signature field element (wrapper + rectangle + label)
   */
  private createSignatureFieldElement(field: any, pdfCanvas: HTMLCanvasElement): HTMLElement | null {
    // Calculate screen position from PDF coordinates (use clientWidth to match form-designer)
    const viewport = {
      width: pdfCanvas.clientWidth,
      height: pdfCanvas.clientHeight
    };

    // ✅ Extract actual page dimensions from PDF viewer DOM (not hardcoded!)
    const pageWrapper = pdfCanvas.closest('[data-page-number]');
    if (!pageWrapper) {
      console.error('❌ Could not find page wrapper for signature field', field.id);
      return null;
    }
    const pageDimensions = this.extractPageDimensions(pageWrapper);

    const screenCoords = this.pdfToScreen(field, viewport, pageDimensions);

    const isCurrentRecipient = Number(field.recipientId) === this.theRecipient.id;
    const color = isCurrentRecipient ? this.signerColor : this.otherSignersColor;

    // Create wrapper div
    const wrapper = document.createElement('div');
    wrapper.className = 'signature-field-wrapper';
    wrapper.setAttribute('data-field-id', field.id);
    wrapper.setAttribute('data-field-type', field.type);
    wrapper.style.position = 'absolute';
    wrapper.style.left = screenCoords.x + 'px';
    wrapper.style.top = screenCoords.y + 'px';
    wrapper.style.width = screenCoords.width + 'px';
    wrapper.style.height = screenCoords.height + 'px';
    wrapper.style.pointerEvents = isCurrentRecipient ? 'auto' : 'none';
    wrapper.style.boxSizing = 'border-box';

    // Create rectangle div
    const rect = document.createElement('div');
    rect.className = 'signature-field-rect';
    if (!isCurrentRecipient) {
      rect.classList.add('other-recipient');
    }
    rect.style.background = this.hexToRGBA(color, isCurrentRecipient ? '0.5' : '0.05');
    rect.style.border = `1px ${isCurrentRecipient ? 'solid' : 'dashed'} ${color}`;
    rect.style.width = '100%';
    rect.style.height = '100%';
    rect.style.cursor = isCurrentRecipient ? 'pointer' : 'not-allowed';
    rect.style.display = 'flex';
    rect.style.alignItems = 'flex-end';
    rect.style.justifyContent = 'center';
    rect.style.transition = 'background 0.2s ease';
    rect.style.position = 'relative';
    rect.style.boxSizing = 'border-box';
    rect.style.opacity = isCurrentRecipient ? '1' : '0.5';

    // Create label
    const label = document.createElement('span');
    label.className = 'signature-label';
    label.textContent = this.getFieldLabel(field);
    label.style.fontSize = '10px';
    label.style.color = '#666';
    label.style.fontFamily = 'Arial, sans-serif';
    label.style.paddingBottom = '2px';
    label.style.zIndex = '1';
    label.style.position = 'relative';

    rect.appendChild(label);
    wrapper.appendChild(rect);

    // Add event listeners for current recipient only
    if (isCurrentRecipient) {
      rect.addEventListener('click', (e) => {
        e.stopPropagation();
        console.log('Signature field clicked:', field);
        this.handleSignatureFieldClick(field);
      });

      rect.addEventListener('mouseenter', () => {
        rect.style.background = this.hexToRGBA(color, '0.3');
      });

      rect.addEventListener('mouseleave', () => {
        rect.style.background = this.hexToRGBA(color, '0.5');
      });
    }

    return wrapper;
  }

  /**
   * Display signature image in a field after signing
   */
  displaySignatureImage(fieldId: string, imageData: string): void {
    console.log(`Displaying signature image for field ${fieldId}`);

    // Find the signature field wrapper
    const wrapper = document.querySelector(`[data-field-id="${fieldId}"]`) as HTMLElement;
    if (!wrapper) {
      console.warn(`Cannot find wrapper for field ${fieldId}`);
      return;
    }

    const rect = wrapper.querySelector('.signature-field-rect') as HTMLElement;
    if (!rect) {
      console.warn(`Cannot find rect for field ${fieldId}`);
      return;
    }

    // Check if image already exists
    let img = this.signatureImageElements.get(fieldId);
    if (!img) {
      img = document.createElement('img');
      img.className = 'signature-image';
      img.style.position = 'absolute';
      img.style.maxWidth = '90%';
      img.style.maxHeight = '90%';
      img.style.objectFit = 'contain';
      img.style.top = '50%';
      img.style.left = '50%';
      img.style.transform = 'translate(-50%, -50%)';
      img.style.pointerEvents = 'none';
      img.style.zIndex = '2';

      wrapper.appendChild(img);
      this.signatureImageElements.set(fieldId, img);
    }

    // Set image source
    const imageUrl = imageData.startsWith('data:image')
      ? imageData
      : `data:image/png;base64,${imageData}`;
    img.src = imageUrl;

    // Hide rectangle background but keep border visible
    rect.style.background = 'transparent';

    console.log(`Signature image displayed for field ${fieldId}`);
  }

  /**
   * Create disabled overlay for other recipients' form fields
   */
  private createDisabledFieldOverlay(field: any, pdfCanvas: HTMLCanvasElement): HTMLElement | null {
    const viewport = {
      width: pdfCanvas.clientWidth,
      height: pdfCanvas.clientHeight
    };

    // ✅ Extract actual page dimensions from PDF viewer DOM (not hardcoded!)
    const pageWrapper = pdfCanvas.closest('[data-page-number]');
    if (!pageWrapper) {
      console.error('❌ Could not find page wrapper for disabled field', field.id);
      return null;
    }
    const pageDimensions = this.extractPageDimensions(pageWrapper);

    const screenCoords = this.pdfToScreen(field, viewport, pageDimensions);
    const color = this.otherSignersColor;

    const overlay = document.createElement('div');
    overlay.className = 'disabled-field-overlay';
    overlay.style.position = 'absolute';
    overlay.style.left = screenCoords.x + 'px';
    overlay.style.top = screenCoords.y + 'px';
    overlay.style.width = screenCoords.width + 'px';
    overlay.style.height = screenCoords.height + 'px';
    overlay.style.background = this.hexToRGBA(color, '0.7'); // Increased from 0.05 to 0.7 for visibility
    overlay.style.border = `1px dashed ${color}`;
    overlay.style.opacity = '1'; // Full opacity (not 0.5)
    overlay.style.pointerEvents = 'auto'; // Changed from 'none' to 'auto' to block clicks
    overlay.style.cursor = 'not-allowed'; // Show unclickable cursor
    overlay.style.boxSizing = 'border-box';
    overlay.style.zIndex = '101'; // Above PDF.js annotations

    return overlay;
  }

  /**
   * Destroy HTML signature overlay for a specific page
   */
  destroySignatureOverlayForPage(pageNumber: number): void {
    if (this.htmlSignatureOverlays.has(pageNumber)) {
      const overlay = this.htmlSignatureOverlays.get(pageNumber);
      overlay?.remove();
      this.htmlSignatureOverlays.delete(pageNumber);
      console.log(`Destroyed HTML signature overlay for page ${pageNumber}`);
    }
  }

}


